<template>

  <v-container fluid>
    
    <!-- 아임포트 상세 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_iam" @keydown.esc="dialog_iam = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_iam = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <vue-json-pretty
                :data="iamData"                  
                >
              </vue-json-pretty>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_iam = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>        

    <!-- 결제 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_payment" @keydown.esc="dialog_payment = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_payment = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-data-table
                :headers="payment_headers"
                :items="paymentItem"
                :no-data-text="$t('common_nodata')"
                hide-default-footer
                class="datatablestyle"
                item-key="IDX"
                >
                <template v-slot:header.IAMCODE>
                  <label class="cheader_normal" >{{$t("eul_payment_col1")}}</label>
                </template>
                <template v-slot:header.COST>
                  <label class="cheader_normal" >{{$t("eul_payment_col2")}}</label>
                </template>
                <template v-slot:header.STATE_NAME>
                  <label class="cheader_normal" >{{$t("eul_payment_col3")}}</label>
                </template>
                <template v-slot:header.MSG>
                  <label class="cheader_normal" >{{$t("eul_payment_col4")}}</label>
                </template>
                <template v-slot:header.REG_DATE>
                  <label class="cheader_normal" >{{$t("eul_payment_col5")}}</label>
                </template>
                <template v-slot:header.CANCEL>
                  <label class="cheader_normal" >{{$t("eul_payment_col6")}}</label>
                </template>

                <template v-slot:item.IAMCODE="{ item }">  
                  <a @click="getiamport(item.IAMCODE)" >{{item.IAMCODE}}</a>
                </template>
                <template v-slot:item.CANCEL="{ item }">  
                  <v-icon small @click="cancel_payment(item)">mdi-delete</v-icon>
                </template>
                <template v-slot:item.COST="{ item }">  
                  <label>{{ priceToString(item.COST)}} {{ item.COST_TYPE == 0 ? "KRW" : "USD" }}</label>
                </template>
              </v-data-table>              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_payment = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>        

    <!-- 프린트 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_print" @keydown.esc="dialog_print = false" max-width="1000px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label2')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_print = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-data-table
                :headers="print_headers"
                :items="printItem"
                :no-data-text="$t('common_nodata')"
                hide-default-footer
                :items-per-page="9999"
                class="datatablestyle"
                item-key="IDX"
                >
                <template v-slot:header.OPTION_NAME>
                  <label class="cheader_normal" >{{$t("eul_print_col1")}}</label>
                </template>
                <template v-slot:header.PRINT_DATE>
                  <label class="cheader_normal" >{{$t("eul_print_col2")}}</label>
                </template>
                <template v-slot:header.PRINT_TYPE>
                  <label class="cheader_normal" >{{$t("eul_print_col3")}}</label>
                </template>
                <template v-slot:header.USER_TYPENAME>
                  <label class="cheader_normal" >{{$t("eul_print_col4")}}</label>
                </template>
                <template v-slot:header.NAME>
                  <label class="cheader_normal" >{{$t("eul_print_col5")}}</label>
                </template>
                <template v-slot:header.TEL>
                  <label class="cheader_normal" >{{$t("eul_print_col6")}}</label>
                </template>

                <template v-slot:item.OPTION_NAME="{ item }">  
                  <label>{{ $i18n.locale === 'ko' ? item.OPTION_NAME : item.OPTION_NAME_ENG }}</label>
                </template>

              </v-data-table>              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_print = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    
    
    <!-- 참가자 정보 팝업 (사용안함)-->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_user" @keydown.esc="dialog_user = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_userinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_user = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="visitorItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="visitorItem.EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field :value="$i18n.locale === 'ko' ? visitorItem.OPTION_NAME : visitorItem.OPTION_NAME_ENG" :label="$t('common_userinfo_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="visitorItem.REGTYPE_NAME" :label="$t('common_userinfo_label18')" disabled></v-text-field>
              </v-row>

              <!-- 행사별 커스텀 기본정보 -->              
              <template v-for="item in infoItem">
                <template v-if="item.SHOWTYPE == 1">
                  <template v-if="item.LANTYPE == 4">
                    
                    <v-row :key="item.INPUT_CODE" dense>
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <img  :height="item.HEIGHT" :width="item.WIDTH" :src="visitorItem['INFO'+item.INPUT_CODE]" class="image"/>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label5')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else-if="item.LANTYPE == 5">
                    <v-row dense :key="item.INPUT_CODE">
                      <label style="color:rgba(0,0,0,0.38)">{{item.NAME}}</label>
                    </v-row>
                    <template v-if="visitorItem['INFO'+item.INPUT_CODE] != null && visitorItem['INFO'+item.INPUT_CODE] != undefined && visitorItem['INFO'+item.INPUT_CODE].length > 1">
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <a :href="visitorItem['INFO'+item.INPUT_CODE]" download target="_blink">File Download</a>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense :key="item.INPUT_CODE" justify="center">
                        <label style="color:rgba(0,0,0,0.38)">{{$t('common_userinfo_label19')}}</label>
                      </v-row>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="item.MAXLINES == 1">
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-textarea dense no-resize outlined height="70"
                        v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-textarea>
                      </v-row>
                    </template>
                    <template v-else>
                      <v-row dense  :key="item.INPUT_CODE">
                        <v-text-field v-if="item.USETYPE == 1" v-model="visitorItem['INFO'+item.INPUT_CODE]" :label="item.NAME" disabled></v-text-field>
                      </v-row>
                    </template>
                  </template>
                </template>
              </template>

              <v-row dense v-if="useInfo.USETEL == 1">
                  <v-text-field v-model="visitorItem.TEL" :label="$t('common_userinfo_label6')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEMAIL == 1">
                  <v-text-field v-model="visitorItem.EMAIL" :label="$t('common_userinfo_label7')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEPW == 1">
                  <v-text-field v-model="visitorItem.PRINT_NUMBER" :label="$t('common_userinfo_label8')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USESEX == 1">
                  <v-text-field v-model="visitorItem.SEX_NAME" :label="$t('common_userinfo_label9')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USEYEAR == 1">
                  <v-text-field v-model="visitorItem.YEAR" :label="$t('common_userinfo_label10')" counter="4" :suffix="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
              <v-row dense v-if="useInfo.USENATION == 1">
                  <v-text-field v-model="visitorItem.NAMEKOR" :label="$t('common_userinfo_label12')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="visitorItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_user = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 행사정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_event" @keydown.esc="dialog_event = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_eventinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_event = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense>
                  <v-text-field v-model="eventItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                  <v-text-field v-model="eventItem.NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="eventItem.EVENT_START" :label="$t('common_eventinfo_label2')" disabled></v-text-field>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="eventItem.EVENT_END" :label="$t('common_eventinfo_label3')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="eventItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="eventItem.TYPENAME" :label="$t('common_eventinfo_label4')" disabled></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_event = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>   
    </v-row>    

    <!-- 입장료 옵션정보 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_option" @keydown.esc="dialog_option = false" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('common_eventinfo_label1')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_option = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense>
                  <v-text-field :value="$i18n.locale == 'ko' ? odItem.NAME : odItem.NAME_ENG"
                    :label="$t('common_userinfo_label4')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="odItem.REG_START" :label="$t('common_eventoption_label1')" disabled></v-text-field>
                </v-col>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field v-model="odItem.REG_END" :label="$t('common_eventoption_label2')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="odItem.STATE_NAME" :label="$t('common_userinfo_label13')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="odItem.REGTYPE_NAME" :label="$t('eventnotice_col2')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-text-field dense v-model="odItem.COST_TYPE" :label="$t('common_eventoption_label3')" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field dense v-model="odItem.COST" :label="$t('common_eventoption_label4')" disabled></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field dense v-model="odItem.COST_USD" :label="$t('common_eventoption_label5')" disabled></v-text-field>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_option = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>   
    </v-row>        

    <!-- 환불 정보 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_refund" @keydown.esc="dialog_refund = false" max-width="800px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label3')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="dialog_refund = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-data-table
                :headers="refund_headers"
                :items="refundItem"
                :no-data-text="$t('common_nodata')"
                hide-default-footer
                class="datatablestyle"
                item-key="IDX"
                >

                <template v-slot:header.DAY>
                  <label class="cheader_normal" >{{$t("eul_refund_col1")}}</label>
                </template>
                <template v-slot:header.RATE>
                  <label class="cheader_normal" >{{$t("eul_refund_col2")}}</label>
                </template>
                <template v-slot:header.ISREFUND>
                  <label class="cheader_normal" >{{$t("eul_refund_col3")}}</label>
                </template>
                                                
                <template v-slot:item.DAY="{ item }">  
                  <template v-if="item.DAY == 0">
                    <label style="text-align: center">{{$t('eul_label4')}}</label>
                  </template>
                  <template v-else>
                    <label style="text-align: center">{{item.DAY}}{{$t('eul_label5')}}</label>
                  </template>
                </template>
                <template v-slot:item.RATE="{ item }">  
                  <label>{{item.RATE}}%</label>
                </template>
                <template v-slot:item.ISREFUND="{ item }">  
                  <template v-if="item.ISREFUND == 0">
                    <label>{{$t('eul_label6')}}</label>
                  </template>
                  <template v-else>
                    <label>{{$t('eul_label7')}}</label>
                  </template>
                </template>
              </v-data-table>              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn" rounded large @click="dialog_refund = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>            


    <!-- 링크 입력 팝업 -->
    <v-row align="center"  justify="center" >
      <v-dialog scrollable overlay-color="#000000FF" persistent v-model="link_dialog" @keydown.esc="link_dialog = false" 
        :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
        :width="$vuetify.breakpoint.smAndDown ? '100%' : '600px'"
        class="none_radius">
        
        <v-card class="dialog_round pa-10">

          <v-card-text>

            <v-row align="center" justify="center" dense>
              <v-col cols="12" align="center"> <!-- 해상도 조절 컬럼 -->

                <v-row dense align="center" justify="center" class="mt-5 mt-md-10 ma-0">
                  <v-col cols="12" md="10" align="start"  class="ma-0 pa-0">
                    <p class="text-md-h6 text-subtitle-2 text-left ma-0 pa-0 dialog_subtitle_eng">{{$t("eul_label8")}}</p>
                  </v-col>
                  <v-col cols="12" md="10" class="ma-0 pa-0">
                    <v-text-field 
                      class="none_radius" color="black" placeholder="Link"
                      single-line v-model="LINKADDR" 
                      :height="$vuetify.breakpoint.smAndDown ? 40 : 50"
                      outlined dense hide-details/>
                  </v-col>
                </v-row>    

            </v-col>
          </v-row>
        </v-card-text>

          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="link_dialog = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save_link">{{$t("common_save")}}</v-btn>
            </v-row>
          </v-card-actions>

        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 이미지 크롭 팝업 (가로) -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="crop_dialog = false" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="crop_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_land"
                :img="imgSrc"
                :outputType="option.outputType"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :centerBox="option.centerBox"
                :high="option.high"
                :infoTrue="option.infoTrue"
                :maxImgSize="option.maxImgSize"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :limitMinSize="option.limitMinSize"
                />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="crop_dialog = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="1000px" >
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="3">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>

            <v-spacer/>
            
            <v-col cols="5" align="end">

              <!-- 개별 출력 버튼 -->
              <template v-if="editedIndex > -1">

                <template v-if="grade > 90">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="printtest(1)"><v-icon>mdi-printer-off</v-icon></v-btn>
                    </template>
                    <span>{{$t('eul_label29')}}</span>
                  </v-tooltip>
                </template>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-3" elevation="1" small @click="printtest(0)"><v-icon>mdi-printer</v-icon></v-btn>
                  </template>
                  <span>{{$t('eul_label30')}}</span>
                </v-tooltip>            
                
              </template>

              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>

          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>

              <v-row dense> 
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedItem.COM_NAME" :label="$t('common_userinfo_label2')" disabled outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedItem.EVENT_NAME" :label="$t('common_userinfo_label3')" disabled outlined dense></v-text-field>
                </v-col>
              </v-row>

              <v-row dense align="center" justify="center"> 
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedItem.IDX" :label="$t('eul_label9')" disabled outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select dense outlined v-model="editedItem.OPTION_IDX" :items="optionItem" :label="$t('common_userinfo_label4')" 
                    :item-text="$i18n.locale == 'ko' ? 'NAME' : 'NAME_ENG'" item-value="IDX"
                    />
                </v-col>
              </v-row>

              <v-row dense align="center" justify="center"> 
                <v-col cols="12" md="6">
                  <v-select dense  v-model="editedItem.REG_TYPE" :items="REGTYPELIST" :label="$t('common_userinfo_label18')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedItem.REGTYPE_NAME" disabled outlined dense></v-text-field>
                </v-col>
              </v-row>

              <v-row dense align="center" justify="center"> 
                <v-col cols="12" md="6">
                  <v-select dense  v-model="editedItem.ISFOREIGNER" :items="FOREINERTYPELIST" :label="$t('common_userinfo_label20')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined />
                </v-col>
                <v-col cols="12" md="6">
                </v-col>
              </v-row>

              <!-- 행사별 커스텀 기본정보 -->        
              <v-row dense>
              <template v-for="item in infoItem">

                <template v-if="item.SHOWTYPE == 1">

                  <template v-if="item.LANTYPE == 4">
                    <template v-if="editedItem['INFO'+item.INPUT_CODE] != null && editedItem['INFO'+item.INPUT_CODE] != undefined && editedItem['INFO'+item.INPUT_CODE].length > 0">
                      <v-col cols="12" md="6" :key="item.INPUT_CODE">
                        <label>{{item.NAME}}</label>
                        <v-row dense  justify="center" >
                          <img  :height="item.HEIGHT" :width="item.WIDTH" :src="editedItem['INFO'+item.INPUT_CODE]" class="image">
                        </v-row>
                        <v-row dense justify="center" class="mt-3">
                          <!-- <v-icon style="width:80px;height:40px;" size="40" color="gray" @click="showImage(item.INPUT_CODE)">mdi-magnify-expand</v-icon> -->
                          <v-icon style="width:80px;height:40px;" size="40" color="gray" @click="fileSelect(item)">mdi-pencil</v-icon>
                          <v-icon style="width:80px;height:40px;" size="40" color="gray" @click="clearFile(item.INPUT_CODE)">mdi-window-close</v-icon>
                        </v-row>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12" md="6" :key="item.INPUT_CODE">
                        <label>{{item.NAME}}</label>
                        <v-row dense class="image-border2" align="center" justify="center">
                          <v-icon style="width:100px;height:100px;" size="100" color="#EDEDED" @click="fileSelect(item)">mdi-image</v-icon>
                          <v-icon style="width:100px;height:100px;" size="100" color="#EDEDED" @click="linkadd(item.INPUT_CODE)">mdi-link</v-icon>
                        </v-row>
                      </v-col>
                    </template>
                  </template>
                  
                  <template v-else-if="item.LANTYPE == 5">
                    <template v-if="editedItem['INFO'+item.INPUT_CODE] != null && editedItem['INFO'+item.INPUT_CODE] != undefined && editedItem['INFO'+item.INPUT_CODE].length > 0">
                      <v-col cols="12" md="6" :key="item.INPUT_CODE">
                        <label>{{item.NAME}}</label>
                        <v-row dense  justify="center" class="d-flex align-center">
                          <a :href="editedItem['INFO'+item.INPUT_CODE]" target="_blank" download>File Download</a>
                          <v-icon class="ml-5" style="width:20px;height:20px;" size="20" color="gray" @click="fileSelect_all(item)">mdi-pencil</v-icon>
                          <v-icon style="width:20px;height:20px;" size="20" color="gray" @click="clearFile(item.INPUT_CODE)">mdi-window-close</v-icon>
                        </v-row>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12" md="6" :key="item.INPUT_CODE">
                        <label>{{item.NAME}}</label>
                        <v-row dense class="image-border2" align="center" justify="center">
                          <v-icon style="width:20px;height:20px;" size="20" color="#EDEDED" @click="fileSelect_all(item)">mdi-upload</v-icon>
                        </v-row>
                      </v-col>
                    </template>
                  </template>

                  <template v-else>
                    <template v-if="item.LANTYPE == 2">
                      <template v-if="item.MAXLINES == 1">
                        <v-col cols="12" md="6" :key="item.INPUT_CODE">
                          <v-textarea dense no-resize outlined height="70"  v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]"></v-textarea>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="6" :key="item.INPUT_CODE">
                          <v-text-field outlined dense  v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]"></v-text-field>
                        </v-col>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="item.MAXLINES == 1">
                        <v-col cols="12" md="6" :key="item.INPUT_CODE">
                          <v-textarea dense no-resize outlined height="70" style="vertical-align:middle"
                             v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-textarea>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="12" md="6" :key="item.INPUT_CODE">
                          <v-text-field outlined dense  v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-text-field>
                        </v-col>
                      </template>
                    </template>
                  </template>
                </template>
                <template v-else>
                  <!-- 사용안함인 컬럼들이라 보이면 안되는데 행사 운영상 필요해서 풀어줌 2023-09-05 
                       기본등록양식에 명단노출 옵션을 별도로 분리해서 사용안함 노출을 더이상 사용하지 않음. 2025-06-01
                  <template v-if="editedItem.COL_TYPE == 1">
                    
                    <template v-if="item.LANTYPE == 4">
                      <v-col cols="12" md="6" :key="item.INPUT_CODE">
                        <label style="color:red">{{item.NAME}}</label>
                        <v-row dense  justify="center" >
                          <img  :height="item.HEIGHT" :width="item.WIDTH" :src="editedItem['INFO'+item.INPUT_CODE]" class="image">
                        </v-row>
                        <v-text-field color="red" outlined dense v-model="editedItem['INFO'+item.INPUT_CODE]" :label="item.NAME"></v-text-field>
                      </v-col>
                    </template>

                    <template v-else>

                      <template v-if="item.LANTYPE == 2">
                        <template v-if="item.MAXLINES == 1">
                          <v-col cols="12" md="6" :key="item.INPUT_CODE">
                            <v-textarea dense no-resize outlined height="70" v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]"></v-textarea>
                          </v-col>
                        </template>
                        <template v-else>
                          <v-col cols="12" md="6" :key="item.INPUT_CODE">
                            <v-text-field outlined dense v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)" :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]"></v-text-field>
                          </v-col>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="item.MAXLINES == 1">
                          <v-col cols="12" md="6" :key="item.INPUT_CODE">
                            <v-textarea dense no-resize outlined height="70" style="vertical-align:middle"
                              v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-textarea>
                          </v-col>
                        </template>
                        <template v-else>
                          <v-col cols="12" md="6" :key="item.INPUT_CODE">
                            <v-text-field outlined dense v-model="editedItem['INFO'+item.INPUT_CODE]" :label="getColumnName(item)"></v-text-field>
                          </v-col>
                        </template>
                      </template>
                    </template>
  
                  </template>
                -->
                </template>
              </template>
              </v-row>

              <v-row dense align="center">
                <v-col cols="12" md="6" v-if="useInfo.USETEL == 1">
                  <v-text-field :rules="[v => !v || !/[^0-9-]/.test(v) || $t('eul_msg1')]" v-model="editedItem.TEL" :label="$t('common_userinfo_label6')" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="useInfo.USEMAIL == 1">
                  <v-text-field v-model="editedItem.EMAIL" :label="$t('common_userinfo_label7')" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="useInfo.USEPW == 1">
                  <v-text-field :rules="[v => Number.isInteger(Number(v)) || $t('common_numberrules')]" v-model="editedItem.PRINT_NUMBER" :label="$t('common_userinfo_label14')" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="useInfo.USESEX == 1">
                  <v-select v-model="editedItem.SEX" :items="SEXLIST" :label="$t('common_userinfo_label9')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined dense/>
                </v-col>
                <v-col cols="12" md="6" v-if="useInfo.USEYEAR == 1">
                  <v-text-field type="number" :rules="[v => Number.isInteger(Number(v)) || $t('common_numberrules'), v => v.length == 4 || $t('eul_msg2')]" oninput="javascript:this.value=this.value.replace(/[^0-9]/g,'');"
                    v-model="editedItem.YEAR" :label="$t('common_userinfo_label10')" counter="4" :suffix="$t('common_userinfo_label13')" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="useInfo.USENATION == 1">
                  <nationdialog :nationname="editedItem.NAMEKOR" @callback="nationcallback" :label="$t('common_userinfo_label12')"></nationdialog>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select dense  v-model="editedItem.STATE" :items="STATELIST" :label="$t('common_userinfo_label13')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedItem.REGSORT" :label="$t('common_userinfo_label21')" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="editedItem.SORT" :label="$t('common_userinfo_label15')" outlined dense></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-textarea v-model="editedItem.COMMENT" outlined :label="$t('common_userinfo_label16')"></v-textarea>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-textarea v-model="editedItem.COMMENT2" outlined :label="$t('common_userinfo_label17')"></v-textarea>
                </v-col>
              </v-row>

              <v-row dense justify="center">
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY1" hide-details outlined dense :label="$t('eventplace_excel10')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY2" hide-details outlined dense :label="$t('eventplace_excel11')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY3" hide-details outlined dense :label="$t('eventplace_excel12')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY4" hide-details outlined dense :label="$t('eventplace_excel13')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY5" hide-details outlined dense :label="$t('eventplace_excel14')" />
                </v-col>
              </v-row>
              <v-row dense justify="center">
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY6" hide-details outlined dense :label="$t('eventplace_excel15')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY7" hide-details outlined dense :label="$t('eventplace_excel16')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY8" hide-details outlined dense :label="$t('eventplace_excel17')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY9" hide-details outlined dense :label="$t('eventplace_excel18')" />
                </v-col>
                <v-col cols="2">
                  <v-text-field v-model="editedItem.KEY10" hide-details outlined dense :label="$t('eventplace_excel19')" />
                </v-col>
              </v-row>


            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
              <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 입장료 옵션 수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="option_dialog" @keydown.esc="option_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label10')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="option_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>

              <v-row dense class="mt-5">
                  <v-select dense v-model="EDIT_OPTION_IDX" :items="optionItem" :label="$t('common_userinfo_label4')" 
                    :item-text="$i18n.locale == 'ko' ? 'NAME' : 'NAME_ENG'" item-value="IDX"/>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="option_dialog = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="changeoptionrun">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 엑셀등록 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="excel_dialog" @keydown.esc="excel_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label11')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="excel_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-progress-linear :indeterminate="excel_prog"/>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field  v-model="SEARCH_COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="SEARCH_EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <!-- 
              <v-row dense>
                  <v-select dense v-model="excelItem.OPTION_IDX" :items="optionItem" :label="$t('common_userinfo_label4')" item-text="NAME" item-value="IDX"/>
              </v-row>
              -->
              <v-row dense>
                  <nationdialog :nationname="excelItem.NAMEKOR" @callback="nationcallbackExcel" :label="$t('common_userinfo_label12')"></nationdialog>
              </v-row>
              <v-row dense>
                <v-file-input
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                  :label="$t('eventinvit_label17')" v-model="uploadFile" dense></v-file-input>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="excel_dialog = false">{{$t("common_close")}}</v-btn>
                <v-btn rounded color="primary" @click="uploadExcel()">{{$t('eul_label12')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>


    <!-- 엑셀수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="excelupdate_dialog" @keydown.esc="excelupdate_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label40')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="excelupdate_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-progress-linear :indeterminate="excel_prog"/>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field  v-model="SEARCH_COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="SEARCH_EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-file-input
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                  :label="$t('eventinvit_label17')" v-model="uploadFile" dense></v-file-input>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="excelupdate_dialog = false">{{$t("common_close")}}</v-btn>
                <v-btn rounded color="primary" @click="uploadUpdateExcel()">{{$t('eul_label12')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>


    <!-- 이메일 발송 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="emailalim_dialog" @keydown.esc="emailalim_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label13')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="emailalim_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              
              <v-row dense> 
                <v-text-field  v-model="SEARCH_COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="SEARCH_EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>

              <!-- 이메일 제목 및 템플릿 선택 -->
              <v-row dense class="mt-0" align="center">
                <v-col cols="6" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_col1') }}</label>
                </v-col>
                <v-col cols="6" class="pa-0" align="end">
                  <comemailtempdialog @callback="selectemailtemplate" :com_idx="SEARCH_COM_IDX" :event_idx="SEARCH_EVENT_IDX" />
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field dense v-model="emailItem.ETEMP_TITLE" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_col2') }}</label>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field dense v-model="emailItem.ETEMP_SENDER" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <v-select hide-details v-model="emailItem.ETEMP_LAN" :items="LANLIST" :label="$t('eul_label20')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                </v-col>
              </v-row>

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("emailtemp_col5")}}</label>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col6')" v-model="emailItem.ED_TITLE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col7')" v-model="emailItem.ED_DATE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col13')" v-model="emailItem.ED_TIME" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col8')" v-model="emailItem.ED_PLACE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col9')" v-model="emailItem.ED_ADDR" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col10')" v-model="emailItem.ED_HOST" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col11')" v-model="emailItem.ED_ORG" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col14')" v-model="emailItem.ED_SPON" hide-details/>
                </v-col>
              </v-row>

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("emailtemp_col12")}}</label>
                </v-col>
              </v-row>
              <v-row dense class="mt-0" v-if="infoItem.length > 0">

                <v-checkbox v-if="infoItem[0].USETYPE == 1" :label="infoItem[0].NAME" 
                  v-model="emailItem.EINFO1" dense hide-details class="mr-5  mt-1"/>

                <v-checkbox v-if="infoItem[1].USETYPE == 1" :label="infoItem[1].NAME" 
                  v-model="emailItem.EINFO2" dense hide-details class="mr-5 mt-1"/>
                
                  <v-checkbox v-if="infoItem[2].USETYPE == 1" :label="infoItem[2].NAME" 
                  v-model="emailItem.EINFO3" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[3].USETYPE == 1" :label="infoItem[3].NAME" 
                  v-model="emailItem.EINFO4" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[4].USETYPE == 1" :label="infoItem[4].NAME" 
                  v-model="emailItem.EINFO5" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[5].USETYPE == 1" :label="infoItem[5].NAME" 
                  v-model="emailItem.EINFO6" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[6].USETYPE == 1" :label="infoItem[6].NAME" 
                  v-model="emailItem.EINFO7" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[7].USETYPE == 1" :label="infoItem[7].NAME" 
                  v-model="emailItem.EINFO8" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[8].USETYPE == 1" :label="infoItem[8].NAME" 
                  v-model="emailItem.EINFO9" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[9].USETYPE == 1" :label="infoItem[9].NAME" 
                  v-model="emailItem.EINFO10" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[10].USETYPE == 1" :label="infoItem[10].NAME" 
                  v-model="emailItem.EINFO11" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[11].USETYPE == 1" :label="infoItem[11].NAME" 
                  v-model="emailItem.EINFO12" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[12].USETYPE == 1" :label="infoItem[12].NAME" 
                  v-model="emailItem.EINFO13" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[13].USETYPE == 1" :label="infoItem[13].NAME" 
                  v-model="emailItem.EINFO14" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[14].USETYPE == 1" :label="infoItem[14].NAME" 
                  v-model="emailItem.EINFO15" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[15].USETYPE == 1" :label="infoItem[15].NAME" 
                  v-model="emailItem.EINFO16" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[16].USETYPE == 1" :label="infoItem[16].NAME" 
                  v-model="emailItem.EINFO17" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[17].USETYPE == 1" :label="infoItem[17].NAME" 
                  v-model="emailItem.EINFO18" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[18].USETYPE == 1" :label="infoItem[18].NAME" 
                  v-model="emailItem.EINFO19" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[19].USETYPE == 1" :label="infoItem[19].NAME" 
                  v-model="emailItem.EINFO20" dense hide-details class="mr-5 mt-1"/>

              </v-row>              

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("emailtemp_col20")}}</label>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col21')" v-model="emailItem.EX_TYPE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col22')" v-model="emailItem.EX_REGDATE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col23')" v-model="emailItem.EX_TIME" hide-details/>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" class="pa-0 mt-5 d-flex align-center">
                  <img
                    width="19" height="19"
                    src='https://blueorigin-mice-staticweb.s3.ap-northeast-2.amazonaws.com/infoicon.png' 
                    />
                  <v-text-field v-model="emailItem.INFO_TITLE1" class="ml-2" outlined dense hide-details
                    :placeholder="$t('emailtemp_col30')"
                    />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" class="pa-0 mt-3">
                  <v-textarea color="#4e6ef7" hide-details
                    v-model="emailItem.INFO_DESC1" :label="$t('emailtemp_col31')" value="" outlined 
                    />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" class="pa-0 mt-5 d-flex align-center">
                  <img
                    width="19" height="19"
                    src='https://blueorigin-mice-staticweb.s3.ap-northeast-2.amazonaws.com/infoicon.png' 
                    />
                  <v-text-field v-model="emailItem.INFO_TITLE2" class="ml-2" outlined dense hide-details
                    :placeholder="$t('emailtemp_col32')"
                    />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" class="pa-0 mt-3">
                  <v-textarea color="#4e6ef7" hide-details
                    v-model="emailItem.INFO_DESC2" :label="$t('emailtemp_col33')" value="" outlined 
                    />
                </v-col>
              </v-row>

              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="emailalim_dialog = false">{{$t("common_close")}}</v-btn>
                <v-btn rounded color="primary" @click="sendEmailAalim">{{$t('eul_label21')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>    


    <!-- 뉴스레터 발송 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="newsletter_dialog" @keydown.esc="closenewsletter" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ $t('eventinvit_msg32') }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="closenewsletter"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="newsLetterItem.COM_NAME" :label="$t('eventinvit_label15')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="newsLetterItem.EVENT_NAME" :label="$t('eventinvit_label16')" disabled></v-text-field>
              </v-row>

              <v-row dense>
                <v-text-field v-model="newsLetterItem.SENDER_NAME" :label="$t('emaillist_label1')"></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]" v-model="newsLetterItem.SENDER_EMAIL" :label="$t('emaillist_label2')"></v-text-field>
              </v-row>

              <v-row dense>
                <emaildialog @callback="selectemail_com" :comidx="SEARCH_COM_IDX" :eventidx="SEARCH_EVENT_IDX" :tempname="SELECT_EMAIL_NAME"/>
              </v-row>

              <v-row dense>
                  <v-textarea counter="150" color="#4e6ef7" v-model="MSG1" :label="$t('emaillist_label4')" value="" outlined :rules="[ v => (v.length <= 100) || $t('emaillist_label5') ]" ></v-textarea>
              </v-row>
              <v-row dense>
                  <v-textarea counter="200" color="#4e6ef7" v-model="MSG2" :label="$t('emaillist_label6')" value="" outlined :rules="[ v => (v.length <= 200) || $t('emaillist_label7') ]" ></v-textarea>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="closenewsletter">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="sendnewsletter">{{$t('eventinvit_label13')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>    

    <!-- QR코드 스캔 입력 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="qr_dialog" @keydown.esc="qr_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row justify="center" class="mt-5">
            <div class="qr-scanner">
              <img :src="require('@/assets/qrimg.png')" 
                width="200" height="200"
                alt="QR Code" />
              <div class="scanner-line"></div>
            </div>
          </v-row>
          <v-row justify="center" class="mt-5">
            <v-col cols="10">
              <div class="text-center">{{$t('eul_label22')}}</div>
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-5">
            <v-col cols="6">
              <v-text-field outlined dense single-line hide-details
                ref="qrRef"  v-model="qr_code" @keyup.enter="sendQrCode"
                :placeholder="$t('eul_label23')"
                />
              </v-col>
          </v-row>

          <v-row justify="center" class="mt-5">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="qr_dialog = false">{{$t("common_close")}}</v-btn>
            <v-btn class="dialog_btn" rounded color="primary" @click="sendQrCode">{{$t('eul_label24')}}</v-btn>
          </v-row>
        </v-card>
      </v-dialog>  
    </v-row>        
    
    <v-row align="center" dense>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col cols="6" md="3" sm="6" xs="6" class="pa-0">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="6" md="3" sm="6" xs="6" class="pa-0">
        <eventdialog  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="6" md="2" sm="6" xs="6" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>      
    </v-row>

    <v-row no-gutters dense justify="end" align="center">
      <v-checkbox v-model="showreview" dense :label="$t('eul_label42')" class="mr-3"/>
      <v-checkbox v-model="checkdate" dense :label="$t('eul_label38')" class="mr-3"/>
      <v-col cols="2" v-if="checkdate">
        <v-menu 
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy 
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="close_datepicker" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="2" v-if="checkdate">                      
        <v-menu 
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="close_datepicker" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>      
      <v-col cols="1" class="pl-1">
        <v-select dense v-model="SEARCH_REGTYPESTATE" :items="SEARCH_REGTYPE" :label="$t('eul_col22')" 
          :item-text="$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined hide-details @change="search_run"
          />
      </v-col>
      <v-col cols="1" class="pl-1">
        <v-select dense v-model="SEARCH_NATIONSTATE" :items="SEARCH_NATION" :label="$t('eul_col21')" 
          :item-text="$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined hide-details @change="search_run"
          />
      </v-col>
      <v-col cols="2" class="pl-1">
        <v-select dense v-model="SEARCH_OPTION" :items="search_optionItem" :label="$t('eul_col4')" 
          :item-text="$i18n.locale == 'ko' ? 'NAME' : 'NAME_ENG'"
          item-value="IDX" outlined hide-details @change="search_run"
          />
      </v-col>
      <v-col cols="1" class="pl-1">
        <v-select dense v-model="SEARCH_STATE" :items="SEARCH_STATELIST" :label="$t('common_userinfo_label13')" 
        :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" outlined hide-details  @change="search_run"
          />
      </v-col>
    </v-row>

    <v-row no-gutters dense justify="end" align="center" class="mt-2">
      
      <v-col cols="2" class="pa-0" align="start">
        <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label><label class="total_label">&nbsp;&nbsp;{{$t("eul_label36")}}</label><label class="total_label">{{selectList.length}}</label>
      </v-col>

      <v-col cols="10" class="pa-0" align="end">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#002060" class="mr-1" elevation="1" small @click="inputQrcode()"><v-icon>mdi-qrcode</v-icon></v-btn>
          </template>
          <span>{{$t('eul_label25')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#fee500" class="mr-1" elevation="1" small @click="sendKakao()"><v-icon>mdi-chat</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%;color:#181600;font-size:16px" color="#fee500" elevation="0" large @click="sendKakao()">알림톡발송</v-btn> -->
          </template>
          <span>{{$t('eul_label26')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#0078d4" class="mr-1" elevation="1" small @click="sendLMS()"><v-icon>mdi-message-processing</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%;color:#181600;font-size:16px" color="#fee500" elevation="0" large @click="sendKakao()">알림톡발송</v-btn> -->
          </template>
          <span>{{$t('eul_label44')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#0078d4" class="mr-1" elevation="1" small @click="sendEmail()"><v-icon>mdi-email-edit-outline</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%;color:#ffffff;font-size:16px" color="#447ec4" elevation="0" large @click="sendEmail()">이메일발송</v-btn> -->
          </template>
          <span>{{$t('eul_label27')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#0078d4" class="mr-3" elevation="1" small @click="openNewsLetter()"><v-icon>mdi-email-newsletter</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%;color:#ffffff;font-size:16px" color="#447ec4" elevation="0" large @click="sendEmail()">이메일발송</v-btn> -->
          </template>
          <span>{{$t('eul_label43')}}</span>
        </v-tooltip>
      
        <!-- 명찰 발향 설정 -->
        <select 
          v-model="print_type"
          class="print-type-select mr-2"
        >
          <option value="basic">{{$i18n.locale == 'ko' ? '기본방향' : 'Basic'}}</option>
          <option value="normal">{{$i18n.locale == 'ko' ? '뒷면 정방향' : 'Back Forward'}}</option>
        </select>

      <template v-if="grade > 90">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="printtest(1)"><v-icon>mdi-printer-off</v-icon></v-btn>
          </template>
          <span>{{$t('eul_label29')}}</span>
        </v-tooltip>
      </template>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-3" elevation="1" small @click="printtest(0)"><v-icon>mdi-printer</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="printtest(0)">명찰출력</v-btn> -->
          </template>
          <span>{{$t('eul_label30')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-3" elevation="1" small @click="changeoption()"><v-icon>mdi-receipt-text-edit</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="changeoption()">입장료옵션수정</v-btn> -->
          </template>
          <span>{{$t('eul_label31')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="newinsert"><v-icon>mdi-account-plus</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="blue_btn_freesize" elevation="0" outlined large @click="newinsert">개별등록</v-btn> -->
          </template>
          <span>{{$t('eul_label33')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-1" elevation="1" small @click="newexcelinsert()"><v-icon>mdi-account-multiple-plus</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="yellow_btn_freesize" elevation="0" outlined large @click="newexcelinsert()">단체등록</v-btn> -->
          </template>
          <span>{{$t('eul_label34')}}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="this.$session.get('GRADE') >= 10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#af1745" class="mr-1" elevation="1" small @click="excelupdate()"><v-icon>mdi-account-multiple-check</v-icon></v-btn>
          </template>
          <span>{{$t('eul_label39')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#000000;background:#f2f2f2" class="mr-3" elevation="1" small @click="downloadExcel()"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="downloadExcel()">{{$t('eventinvit_label23')}}</v-btn> -->
          </template>
          <span>{{$t('eul_label35')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#4e6ef7" class="mr-3" elevation="1" small @click="startDownload()"><v-icon>mdi-file-download</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn> -->
          </template>
          <span>{{$t("common_downexcel")}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#af1745"  elevation="1" small @click="deleteall()"><v-icon>mdi-delete</v-icon></v-btn>
            <!-- <v-btn v-on="on" v-bind="attrs" style="width:94%;color:#ffffff;font-size:16px" color="#FF0000" elevation="0" large @click="deleteall()">선택삭제</v-btn> -->
          </template>
          <span>{{$t('eul_label32')}}</span>
        </v-tooltip>

      </v-col>
  </v-row>

  <v-row align="start">
    <v-col>

      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        show-select
        v-model="selectList"
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        mobile-breakpoint="0"
        height="620px"
        fixed-header
        ref="datatable"
        >
        <template v-slot:header.REGSORT>
          <a :class="sort_name=='REGSORT'?'cheader_sortselect':'cheader_sort'" @click="customsort('REGSORT')">{{$t('eul_col23')}}</a>
        </template>
        <template v-slot:header.SORT>
          <a :class="sort_name=='SORT'?'cheader_sortselect':'cheader_sort'" @click="customsort('SORT')">{{$t('eul_col1')}}</a>
        </template>
        <template v-slot:header.IDX>
          <a :class="sort_name=='IDX'?'cheader_sortselect':'cheader_sort'" @click="customsort('IDX')">{{$t('eul_col2')}}</a>
        </template>
        <template v-slot:header.EVENT_NAME>
          <a :class="sort_name=='EVENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_NAME')">{{$t('eul_col3')}}</a>
        </template>
        <template v-slot:header.OPTION_NAME>
          <a :class="sort_name=='OPTION_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('OPTION_NAME')">{{$t('eul_col4')}}</a>
        </template>
        <template v-slot:header.REGTYPE_NAME>
          <a :class="sort_name=='REGTYPE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('REGTYPE_NAME')">{{$t('eul_col16')}}</a>
        </template>
        <template v-slot:header.STATE_NAME>
          <a :class="sort_name=='STATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE_NAME')">{{$t('eul_col5')}}</a>
        </template>
        <template v-slot:header.USER_TYPENAME>
          <a :class="sort_name=='USER_TYPENAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('USER_TYPENAME')">{{$t('eul_col6')}}</a>
        </template>

        
        <template v-slot:header.ISFOREIGNER>
          <a :class="sort_name=='ISFOREIGNER'?'cheader_sortselect':'cheader_sort'" @click="customsort('ISFOREIGNER')">{{$t('eul_col20')}}</a>
        </template>

        <template v-slot:header.INFO1>
          <a :class="sort_name=='INFO1'?'cheader_sortselect':'cheader_sort'" @click="customsort('INFO1')">{{$t('eul_col7')}}</a>
        </template>
        <template v-slot:header.TEL>
          <a :class="sort_name=='TEL'?'cheader_sortselect':'cheader_sort'" @click="customsort('TEL')">{{$t('eul_col8')}}</a>
        </template>
        <template v-slot:header.EMAIL>
          <a :class="sort_name=='EMAIL'?'cheader_sortselect':'cheader_sort'" @click="customsort('EMAIL')">{{$t('eul_col15')}}</a>
        </template>
        <template v-slot:header.COST>
          <a :class="sort_name=='COST'?'cheader_sortselect':'cheader_sort'" @click="customsort('COST_ORDER')">{{$t('eul_col9')}}</a>
        </template>
        <template v-slot:header.REG_DATE>
          <a :class="sort_name=='REG_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('REG_DATE')">{{$t('eul_col10')}}</a>
        </template>
        <template v-slot:header.PAY_DATE>
          <a :class="sort_name=='PAY_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('PAY_DATE')">{{$t('eul_col18')}}</a>
        </template>
        <template v-slot:header.PRINTCNT>
          <a :class="sort_name=='PRINTCNT'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINTCNT')">{{$t('eul_col11')}}</a>
        </template>
        <template v-slot:header.PRINT_DATE>
          <a :class="sort_name=='PRINT_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINT_DATE')">{{$t('eul_col12')}}</a>
        </template>
        <template v-slot:header.MKTAGREE>
          <a :class="sort_name=='MKTAGREE'?'cheader_sortselect':'cheader_sort'" @click="customsort('MKTAGREE')">{{$t('eul_col17')}}</a>
        </template>

        <template v-slot:header.ISINSPECT>
          <a :class="sort_name=='ISINSPECT'?'cheader_sortselect':'cheader_sort'" @click="customsort('ISINSPECT')">{{$t('eul_col19')}}</a>
        </template>


        <template v-slot:header.payment>
          <label class="cheader_normal" >{{$t("eul_col13")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eul_col14")}}</label>
        </template>

        <!-- 기본등록양식 -->
        <template v-for="(cname, index) in infoItem" v-slot:[`header.INFO${index+1}`]>
          <a v-bind:key="index" :class="sort_name == `INFO${index+1}` ? 'cheader_sortselect':'cheader_sort'" @click="customsort(`INFO${index+1}`)">{{ cname.NAME }}</a>
        </template>

        <!-- 선택등록양식 컬럼 -->
        <template v-for="cname in header_names" v-slot:[`header.${cname.IDX}`]>
            <a v-bind:key="cname.IDX" :class="sort_name == cname.IDX ? 'cheader_sortselect':'cheader_sort'" @click="customsort(`${cname.IDX}`)">
              {{ cname.TITLE }}
              <div class="resize-handle" @mousedown="startResize(cname.IDX, $event)"><v-icon dense>mdi-drag-vertical-variant</v-icon></div>
            </a>
        </template>

        <template v-slot:item.USER_IDX="{ item }">  
          <template v-if="item.USER_IDX == null">
            <td>{{$t('common_member2')}}</td>
          </template>
          <template v-else>
            <td>{{$t('common_member')}}</td>
          </template>
        </template>

        <template v-slot:item.ISFOREIGNER="{ item }">  
          <template v-if="item.ISFOREIGNER == 0">
            <td>{{$t('eventlist_label36')}}</td>
          </template>
          <template v-else>
            <td>{{$t('eventlist_label37')}}</td>
          </template>
        </template>

        <template v-slot:item.EVENT_NAME="{ item }">  
          <a @click="loadevent(item.EVENT_IDX)" >{{item.EVENT_NAME}}</a>
        </template>
        <template v-slot:item.OPTION_NAME="{ item }">  
          <a @click="loadoption(item.EVENT_IDX, item.OPTION_IDX)" >{{ $i18n.locale == 'ko' ? item.OPTION_NAME : item.OPTION_NAME_ENG }}</a>
        </template>

        <template v-slot:item.INFO1="{ item }">  
          <!-- <a @click="loadvisitor(item.IDX, item.EVENT_IDX)" >{{item.INFO1}}</a> -->
          <a @click="edit_item(item)" >{{item.INFO1}}</a>
        </template>

        <template v-slot:item.INFO2="{ item }">  
          <!-- 원래 블루오리진 이미지만 표현했는데 요청으로 해제함. 2024-05-25 -->
          <!-- <template v-if="item.INFO2.startsWith('https://blueorigin')"> -->
          <template v-if="item.INFO2.startsWith('http')">
            <template v-if="isImageUrl(item.INFO2)">
              <template v-if="isImageUrl(item.INFO2)">
                <v-img :src="item.INFO2" width="100" height="80" contain/>
              </template>
              <template v-else>
                <a style="text-decoration: none;" :href="item.INFO2" target="_blink" download>File Download</a>
              </template>
            </template>
            <template v-else>
              <a>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO2 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO3="{ item }">  
          <template v-if="item.INFO3.startsWith('http')">
            <template v-if="isImageUrl(item.INFO3)">
              <v-img :src="item.INFO3" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO3" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO3 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO4="{ item }">  
          <template v-if="item.INFO4.startsWith('http')">
            <template v-if="isImageUrl(item.INFO4)">
              <v-img :src="item.INFO4" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO4" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO4 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO5="{ item }">  
          <template v-if="item.INFO5.startsWith('http')">
            <template v-if="isImageUrl(item.INFO5)">
              <v-img :src="item.INFO5" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO5" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO5 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO6="{ item }">  
          <template v-if="item.INFO6.startsWith('http')">
            <template v-if="isImageUrl(item.INFO6)">
              <v-img :src="item.INFO6" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO6" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO6 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO7="{ item }">  
          <template v-if="item.INFO7.startsWith('http')">
            <template v-if="isImageUrl(item.INFO7)">
              <v-img :src="item.INFO7" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO7" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO7 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO8="{ item }">  
          <template v-if="item.INFO8.startsWith('http')">
            <template v-if="isImageUrl(item.INFO8)">
              <v-img :src="item.INFO8" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO8" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO8 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO9="{ item }">  
          <template v-if="item.INFO9.startsWith('http')">
            <template v-if="isImageUrl(item.INFO9)">
              <v-img :src="item.INFO9" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO9" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO9 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO10="{ item }">  
          <template v-if="item.INFO10.startsWith('http')">
            <template v-if="isImageUrl(item.INFO10)">
              <v-img :src="item.INFO10" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO10" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO10 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO11="{ item }">  
          <template v-if="item.INFO11.startsWith('http')">
            <template v-if="isImageUrl(item.INFO11)">
              <v-img :src="item.INFO11" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO11" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO11 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO12="{ item }">  
          <template v-if="item.INFO12.startsWith('http')">
            <template v-if="isImageUrl(item.INFO12)">
              <v-img :src="item.INFO12" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO12" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO12 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO13="{ item }">  
          <template v-if="item.INFO13.startsWith('http')">
            <template v-if="isImageUrl(item.INFO13)">
              <v-img :src="item.INFO13" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO13" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO13 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO14="{ item }">  
          <template v-if="item.INFO14.startsWith('http')">
            <template v-if="isImageUrl(item.INFO14)">
              <v-img :src="item.INFO14" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO14" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO14 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO15="{ item }">  
          <template v-if="item.INFO15.startsWith('http')">
            <template v-if="isImageUrl(item.INFO15)">
              <v-img :src="item.INFO15" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO15" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO15 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO16="{ item }">  
          <template v-if="item.INFO16.startsWith('http')">
            <template v-if="isImageUrl(item.INFO16)">
              <v-img :src="item.INFO16" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO16" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO16 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO17="{ item }">  
          <template v-if="item.INFO17.startsWith('http')">
            <template v-if="isImageUrl(item.INFO17)">
              <v-img :src="item.INFO17" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO17" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO17 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO18="{ item }">  
          <template v-if="item.INFO18.startsWith('http')">
            <template v-if="isImageUrl(item.INFO18)">
              <v-img :src="item.INFO18" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO18" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO18 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO19="{ item }">  
          <template v-if="item.INFO19.startsWith('http')">
            <template v-if="isImageUrl(item.INFO19)">
              <v-img :src="item.INFO19" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO19" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO19 }}</label>
          </template>
        </template>
        <template v-slot:item.INFO20="{ item }">  
          <template v-if="item.INFO20.startsWith('http')">
            <template v-if="isImageUrl(item.INFO20)">
              <v-img :src="item.INFO20" width="100" height="80" contain/>
            </template>
            <template v-else>
              <a style="text-decoration: none;" :href="item.INFO20" target="_blink" download>File Download</a>
            </template>
          </template>
          <template v-else>
            <label>{{ item.INFO20 }}</label>
          </template>
        </template>
        

        <template v-slot:item.PRINTCNT="{ item }">  
            <a @click="getprintlist(item.IDX, item.EVENT_IDX)">{{ item.PRINTCNT }}</a>
        </template>     
        <template v-slot:item.payment="{ item }">  
            <v-icon small @click="getpaymentlist(item.IDX, item.EVENT_IDX)">mdi-link</v-icon>
        </template>     
        <template v-slot:item.refund="{ item }">  
            <v-icon small @click="getrefundlist(item.EVENT_IDX, item.COM_IDX)">mdi-link</v-icon>
        </template>     
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" style="font-size:16px" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn style="font-size:16px" color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn class="font-size:16px" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" style="font-size:16px" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        @change="search_run"
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
//import dateFormat from 'dateformat'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import XLSX from 'xlsx-js-style'
import moment from 'moment'
import 'cropperjs/dist/cropper.css';
import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리

import calculateSize from 'calculate-size'
import cmvalidation from '../assets/js/cmvalidation.js'
// eslint-disable-next-line no-unused-vars
import DRBackground from '../dragndrop/DRBackground.js'
// eslint-disable-next-line no-unused-vars
import DRComponent from '../dragndrop/DRComponent.js'
// eslint-disable-next-line no-unused-vars
import DRModel from '../dragndrop/DRModel.js'
import FontFaceObserver from 'fontfaceobserver';

export default {

    components:{
      VueCropper,
      VueJsonPretty
    },

    data: () => ({
      test: '취미',

      print_type: "basic",  //명찰 뒷면 방향

      //뉴스레터 발송
      SELECT_EMAIL_IDX:null,
      SELECT_EMAIL_NAME:'',
      newsLetterItem:{},
      newsdefaultItem: {
          PHONE:null,
          USER_IDX:null,
          COM_IDX:null,
          COM_NAME:'',
          EVENT_IDX:null,
          EVENT_NAME:'',
      },
      MSG1:'',  //초대인사
      MSG2:'',  //행사정보
      MSG3:'',  //주의사항

      showreview : false,
      checkdate : false,
      
      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',

      //파일 업로드
      uploadFile : null,

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          INFO1:'',
          INFO2:'',
          INFO3:'',
          INFO4:'',
          INFO5:'',
          INFO6:'',
          INFO7:'',
          INFO8:'',
          INFO9:'',
          INFO10:'',
          INFO11:'',
          INFO12:'',
          INFO13:'',
          INFO14:'',
          INFO15:'',
          INFO16:'',
          INFO17:'',
          INFO18:'',
          INFO19:'',
          INFO20:'',

          TEL:null,
          EMAIL:null,
          USER_IDX:null,
          SEX:1,
          YEAR:'1985',
          NATION:'KR',
          NAMEKOR: '대한민국',
          REG_TYPE:0,
          STATE:1,
          COM_IDX:null,
          COM_NAME:'',
          EVENT_IDX:null,
          EVENT_NAEM:'',
          SORT:null,
          KEY1:'',
          KEY2:'',
          KEY3:'',
          KEY4:'',
          KEY5:'',
          KEY6:'',
          KEY7:'',
          KEY8:'',
          KEY9:'',
          KEY10:'',
      },
      editedItem: {
      },
      
      useInfo:{},

      //엑셀처리
      excelItem: {},
      excelupdate_dialog: false,
      excel_dialog: false,
      excel_prog: false,


      infoItem:[],    //행사별 기본접수양식 커스텀 정보
      optionItem:[],  //행사별 옵션정보
      search_optionItem:[],  //행사별 옵션정보 검색용

      //테이블 정의
      headers: [
        {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
        {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
        {text: '등록번호', value: 'IDX', width:100, sortable: false, align:'center' },
        {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
        {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
        {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
        {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
        {text: '구분', value: 'ISFOREIGNER', width:80,sortable: false, align:'center'},
        {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
        {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
        {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },

        {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
        {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

        {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
        {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
        {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },

        {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
        {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
        
        {text: '만족도조사', value: 'ISINSPECT', width:120,sortable: false, align:'center' },
        {text: '마케팅동의', value: 'MKTAGREE', width:120,sortable: false, align:'center' },
        
        {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
        {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
      ],
      itemList: [],
      selectList: [],
      header_names:[],

      sort_name: 'IDX',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
        , {NAME:'500', VALUE:500}
        , {NAME:'1000', VALUE:1000}
      ],    
      SEARCH_STATELIST: [
          {name:'전체', name2:"All",      value:-1}
        , {name:'접수', name2:"Register", value:1}
        , {name:'결제', name2:"Payment",  value:2}
        , {name:'출력', name2:"Print",    value:3}
        , {name:'입장', name2:"Watch",    value:4}
        , {name:'취소', name2:"Cancel",   value:5}
        , {name:'환불', name2:"Refund",   value:6}
      ],
      SEARCH_REGTYPE: [
          {name:'전체', name2:"All",        value:-1}
        , {name:'현장', name2:"On-site",    value:1}
        , {name:'사전', name2:"Advance",    value:2}
      ],
      SEARCH_NATION: [
          {name:'전체', name2:"All",          value:-1}
        , {name:'내국인', name2:"Local",      value:0}
        , {name:'외국인', name2:"Foreigner",  value:1}
      ],
      STATELIST: [
          {name:'접수', name2:"Register", value:1}
        , {name:'결제', name2:"Payment", value:2}
        , {name:'출력', name2:"Print", value:3}
        , {name:'입장', name2:"Watch", value:4}
        , {name:'취소', name2:"Cancel", value:5}
        , {name:'환불', name2:"Refund", value:6}
      ],
      SEXLIST:[
          {name:'남성', name2:"male",   value:1}
        , {name:'여성', name2:"female", value:2}
      ],
      REGTYPELIST: [
          {name:'자동', name2:"Auto",  value:0}
        , {name:'현장', name2:"On-site", value:1}
        , {name:'사전', name2:"Advance", value:2}
      ],
      FOREINERTYPELIST: [
          {name:'내국인', name2:"LOCAL",    value:0}
        , {name:'외국인', name2:"FOREIGNER", value:1}
      ],
      
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      SEARCH_STATE: -1,
      SEARCH_NATIONSTATE: -1,
      SEARCH_REGTYPESTATE: -1,
      SEARCH_OPTION: -1,
      grade : 0,

      dialog_user:false,
      dialog_event:false,
      dialog_option:false,
      dialog_print:false,
      visitorItem: {},
      eventItem: {},
      odItem: {},
      printItem:[],

      //테이블 정의
      print_headers: [
        {text: '등록 카테고리', value: 'OPTION_NAME', width:200, sortable: false, align:'center'},
        {text: '출력일시', value: 'PRINT_DATE',width:200,  sortable: false, align:'center' },
        {text: '출력타입', value: 'PRINT_TYPE', width:120, sortable: false, align:'center' },
        {text: '회원', value: 'USER_TYPENAME', width:120, sortable: false, align:'center'},
        {text: '이름', value: 'NAME', width:200, sortable: false, align:'center' },
        {text: '전화번호', value: 'TEL', width:200, sortable: false, align:'center' },
      ],

      paymentItem:[],
      dialog_payment:false,
      payment_event_idx:null,
      payment_visitor_idx:null,
      payment_headers: [
        {text: '결제코드', value: 'IAMCODE', sortable: true, align:'center'},
        {text: '결제금액', value: 'COST', sortable: true, align:'right' },
        {text: '상태', value: 'STATE_NAME', sortable: true, align:'center'},
        {text: '메시지', value: 'MSG', sortable: true, align:'center'},
        {text: '결제일시', value: 'REG_DATE', sortable: false, align:'center' },
        {text: '결제취소', value: 'CANCEL', sortable: true, align:'center'},
      ],

      refundItem:[],
      dialog_refund:false,
      refund_headers: [
        {text: '기준일',    value: 'DAY', sortable: true, align:'center' },
        {text: '환불(%)',   value: 'RATE', sortable: true, align:'center'},
        {text: '환불가능유무',  value: 'ISREFUND', sortable: true, align:'center'},
      ],

      dialog_iam:false,
      iamData:{},
      
      option_dialog: false,
      EDIT_OPTION_IDX: null,

      //명찰출력 테스트
      designList:null,
      fontList:[],
      comfontList:new Map(),

      link_dialog: false,
      link_index:0,
      LINKADDR:"",

      //신규 크롭 파라메터
      option: {
        img: "",
        size: 1,
        full: true,
        outputType: "jpg",
        canMove: true,
        fixed: true,          //크롭박스 비율 고정
        fixedNumber: [1,1],  //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:300,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:300,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1200,
        limitMinSize: [100, 100]
      },            
      crop_dialog:false,
      photo_index:'',
      imgSrc:'',
      
      emailalim_dialog:false,
      newsletter_dialog:false,

      qr_dialog:false,
      qr_code:"",

      LANLIST:[
          {name:'한국어', name2:"Korean",  value:0}
        , {name:'영어',  name2:"English",   value:1}
      ],
      
      emaildefaultItem: {
          ETEMP_IDX:'',
          ADMIN_IDX:1,

          ETEMP_TITLE:"",
          ETEMP_SENDER:"",
          ETEMP_LAN:0,

          ED_TITLE:1,
          ED_DATE:1,
          ED_TIME:0,
          ED_PLACE:1,
          ED_ADDR:1,
          ED_HOST:1,
          ED_ORG:1,
          ED_SPON:1,

          EINFO1:1,
          EINFO2:0,
          EINFO3:0,
          EINFO4:0,
          EINFO5:0,
          EINFO6:0,
          EINFO7:0,
          EINFO8:0,
          EINFO9:0,
          EINFO10:0,
          EINFO11:0,
          EINFO12:0,
          EINFO13:0,
          EINFO14:0,
          EINFO15:0,
          EINFO16:0,
          EINFO17:0,
          EINFO18:0,
          EINFO19:0,
          EINFO20:0,

          EX_TYPE:1,
          EX_REGDATE:1,
          EX_TIME:0,

          INFO_TITLE1:'',
          INFO_DESC1:'',
          INFO_TITLE2:'',
          INFO_DESC2:'',

      },
      emailItem: {
      },      

      columnWidths: {}, // 동적으로 업데이트
      columnIdx: null,
      startX: 0,
      initialWidth: 0,

    }),


    beforeDestroy(){
      //아이폰의 경우 찌거기 제거
      let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
      if(indexcnt > -1){

        let elements = document.getElementsByName("imageinputcamera");
        for(var i=0, len=elements.length ; i != len; ++i){
            elements[0].parentNode.removeChild(elements[0]);
        }

        let elements2 = document.getElementsByName("inputfile");
        for(var j=0, len2=elements2.length ; j != len2; ++j){
            elements2[0].parentNode.removeChild(elements2[0]);
        }

      }
    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");
      
      this.search_start_date  = this.$session.get("EVENT_START");
      if(this.search_start_date == null || this.search_start_date == undefined){
        this.search_start_date = moment().format("YYYY-MM-DD");
      }
      this.search_end_date    = this.$session.get("EVENT_END");
      if(this.search_end_date == null || this.search_end_date == undefined){
        this.search_end_date   = moment().format("YYYY-MM-DD");
      }

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }

      //폰트 읽기
      this.$http.post(this.$host+'/api/FontList',{
        search_keyword:""
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              this.fontList.splice(0, this.fontList.length);   //데이터 초기화
              list.forEach(element => {
                //폰트 등록
                //var temp_font = new FontFace(element.NAME, "url('"+element.FONTURL+"')");
                //document.fonts.add(temp_font);
                this.fontList.push(element);
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
          
      });

    },

    create(){

    },

    watch: {
      qr_dialog(newValue) {
        if(newValue) {
          //$nextTick은 돔 업데이트가 처리된 후 호출됨, 즉 돔 업데이트 후 순차 처리가 가능함.
          this.$nextTick(() => {
            //QR 다이얼로그가 열릴 때 해당 다이얼의 인풋에 포커스를 준다. (QR입력을 받기 위해서)
            
            //this.$refs.qrRef.focus();
            setTimeout(() => {
              this.$refs.qrRef.focus();
            }, 300); // 300ms 지연, 애니메이션에 따라 조정할 수 있음            
          });
        }
      }
    },    

    methods: {

      startResize(cidx, event) {

        this.columnIdx      = cidx;
        const columnElement = document.querySelector(`.${this.columnIdx}`);

        if (columnElement) {
          this.columnIdx      = cidx;
          this.startX         = event.clientX;
          this.initialWidth   = columnElement.offsetWidth; // 초기 너비 저장
        }

        // 이벤트 등록
        document.addEventListener("mousemove", this.resizeColumn);
        document.addEventListener("mouseup", this.stopResize);
      },      
      resizeColumn(event) {
        if (this.columnIdx) {
          const diffX = event.clientX - this.startX;
          const newWidth = Math.max(this.initialWidth + diffX, 50); // 최소 너비 50px
          this.columnWidths[this.columnIdx] = `${newWidth}px`;

          const columnElement = document.querySelector(`.${this.columnIdx}`);
          if (columnElement) {
            columnElement.style.width = `${newWidth}px`;
            columnElement.style.minWidth = `${newWidth}px`;

          }

        }
      },
      stopResize() {

        setTimeout(() => {
          this.columnIdx = null;
        }, 300)

        document.removeEventListener("mousemove", this.resizeColumn);
        document.removeEventListener("mouseup", this.stopResize);
        
      },


      isImageUrl(url){
        // 이미지 확장자의 배열
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
        try {
          // URL을 객체로 변환
          const urlObject = new URL(url);
          // 파일 이름에서 확장자를 추출
          const pathname = urlObject.pathname;
          const extension = pathname.split('.').pop().toLowerCase(); // 소문자로 변환
          // 확장자가 이미지 확장자 목록에 있는지 확인
          return imageExtensions.includes(extension);
        } catch (error) {
          // URL 객체 생성에 실패하면 잘못된 URL이므로 이미지가 아님
          return false;
        }
      },

      close_datepicker(){
        this.date1 = false;
        this.date2 = false;
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);
        this.search_run();
      },
      
      test(){
      },

      inputQrcode(){
        //QR코드 입력 대기
        if(this.SEARCH_EVENT_IDX == null || this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == ''){
          this.$alert(this.$t('eul_msg3'));
          return;
        }        

        this.qr_code = "";
        this.qr_dialog = true;
      },

      sendQrCode(){
        if(this.qr_code.length == 0){
          this.$alert(this.$t('eul_msg4'));
          return;
        }
        this.qr_dialog = false;
        
        this.loadQrcode();

      },


      //선택정보 삭제
      deleteall(){

        
        if(this.selectList.length == 0){
          this.$alert(this.$t('eul_msg5'));
          return;
        }

        this.$confirm(this.$t('eul_msg6'))
        .then(() => {
          var uploaditem = [];
          this.selectList.forEach(item=>{
            uploaditem.push({VISITOR_IDX:item.IDX, EVENT_IDX:item.EVENT_IDX, ADMIN_IDX:item.ADMIN_IDX});
          });

          //서버로 전송해서 처리
          this.$http.post(this.$host+'/api/VisitorDeleteAll',{
              JSONVALUE: escape(JSON.stringify(uploaditem))
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.page = 0;
                this.loadpage(1);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_error"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.$alert(this.$t("common_delete_error"));
          });

        });

      },      

      //뉴스레터 발송 설정 오픈
      openNewsLetter(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        if(this.selectList.length == 0){
          this.$alert(this.$t('eul_msg113'));
          return;
        }
        
        this.newsLetterItem = Object.assign({}, this.newsdefaultItem);
        this.newsLetterItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.newsLetterItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.newsLetterItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.newsLetterItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.newsletter_dialog = true;
      },      

      //뉴스레터 발송
      sendnewsletter(){

        if(this.newsLetterItem.SENDER_NAME  == undefined || this.newsLetterItem.SENDER_NAME.length < 1){
          this.$alert(this.$t('emaillist_msg5'));
          return;
        } 

        if(this.newsLetterItem.SENDER_EMAIL  == undefined || this.newsLetterItem.SENDER_EMAIL.length < 1){
          this.$alert(this.$t('emaillist_msg6'));
          return;
        } 

        var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[0-9a-zA-Z][-_.0-9a-zA-Z]*(\.[a-zA-Z]{2,})+$/i;
        if(!emailVal.test(this.newsLetterItem.SENDER_EMAIL)){
          this.$alert(this.$t('emaillist_msg7'));
          return;
        } 

        if(this.MSG1  == undefined || this.MSG1.length < 1){
          this.$alert(this.$t('emaillist_msg8'));
          return;
        } 

        if(this.SELECT_EMAIL_IDX == null || this.SELECT_EMAIL_IDX == undefined){
          this.$alert(this.$t('emaillist_msg9'));
          return;
        }

        const vlist = [];
        this.selectList.forEach(element=>{
          if( element.EMAIL == null || element.EMAIL == undefined || element.EMAIL.trim().length < 1 || !emailVal.test(element.EMAIL.trim()) ){
              return; //continue
          }
          vlist.push(element.EMAIL);
        });

        if(vlist.length == 0){
          this.$alert(this.$t('eul_msg10'));
          return;
        }

        if(vlist.length > 1000){
          this.$alert(this.$t('eul_msg11'));
          return;
        }


        this.$http.post(this.$host+'/api/newsLetterEmailUpload',{
            COM_IDX: this.newsLetterItem.COM_IDX
          , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          , EVENT_IDX: this.newsLetterItem.EVENT_IDX
          , EMAIL_IDX: this.SELECT_EMAIL_IDX
          , EVENTNAME: escape(this.SEARCH_EVENT_NAME)
          , SENDERNAME: escape(this.newsLetterItem.SENDER_NAME)
          , SENDERMAIL: this.newsLetterItem.SENDER_EMAIL
          , MSG1: this.MSG1 == undefined || this.MSG1.length < 1 ? "" : escape(this.MSG1)
          , MSG2: this.MSG1 == undefined || this.MSG2.length < 1 ? "" : escape(this.MSG2)
          , LAN_CODE:this.$i18n.locale          
          , JSONVALUE: escape(JSON.stringify(vlist))
          
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          this.newsletter_dialog = false;
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('eul_msg12'));

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eul_msg13'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });


      },

      closenewsletter(){

        this.newsletter_dialog     = false
        setTimeout(() => {
          this.newsLetterItem = Object.assign({}, this.newsdefaultItem)
        }, 300)

      },

      //이메일 발송
      sendEmail(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        if(this.selectList.length == 0){
          this.$alert(this.$t('eul_msg7'));
          return;
        }

        //이메일 디폴트값 복제
        this.emailItem = Object.assign({}, this.emaildefaultItem);
        this.emailalim_dialog = true;
      },

      sendEmailAalim(){
        
        var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[-_.0-9a-zA-Z][-_.0-9a-zA-Z]*.[a-zA-Z]{2,3}$/i;

        if(this.emailItem.ETEMP_SENDER  == undefined || this.emailItem.ETEMP_SENDER.trim().length < 1){
          this.$alert(this.$t('eul_msg8'));
          return;
        } 
        if(this.emailItem.ETEMP_TITLE  == undefined || this.emailItem.ETEMP_TITLE.trim().length < 1){
          this.$alert(this.$t('eul_msg9'));
          return;
        } 

        const vlist = [];
        this.selectList.forEach(element=>{
          if( element.EMAIL == null || element.EMAIL == undefined || element.EMAIL.trim().length < 1 || !emailVal.test(element.EMAIL.trim()) ){
              return; //continue
          }
          vlist.push(element.IDX);
        });

        if(vlist.length == 0){
          this.$alert(this.$t('eul_msg10'));
          return;
        }

        if(vlist.length > 1000){
          this.$alert(this.$t('eul_msg11'));
          return;
        }


        this.$http.post(this.$host+'/api/EmailAlimUpload',{
          ADMIN_IDX: this.$session.get("ADMIN_IDX"),
          EVENT_IDX: this.SEARCH_EVENT_IDX,
          COM_IDX: this.SEARCH_COM_IDX,
          LAN_CODE:this.$i18n.locale,
          EMAILVALUE: escape(JSON.stringify(this.emailItem)),
          JSONVALUE: escape(JSON.stringify(vlist))
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          this.emailalim_dialog = false;
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('eul_msg12'));

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eul_msg13'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });


      },


      //알림톡 발송
      sendKakao(){

        //const encodedValue = 'Castling%0D%5CnInvestment%20Group';
        //const encodedValue = '%EA%B7%B8%EB%A3%B9';
        //var encodedText = decodeURIComponent(encodedValue);

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        if(this.selectList.length == 0){
          this.$alert(this.$t('eul_msg14'));
          return;
        }

        this.$confirm(this.$t('eul_msg15'))
        .then(() => {
          
          //!element.TEL.replace(/-/g,"").startsWith("010")
          
          const vlist = [];
          this.selectList.forEach(element=>{
            if( element.TEL == null || element.TEL == undefined || element.TEL.length < 1 ){
                return; //continue
            }
            vlist.push(element.IDX);
          });

          this.sendKakaoAalimTalk(vlist);

        });        

      },
      

      sendKakaoAalimTalk(vlist){

        if(vlist.length == 0){
          this.$alert(this.$t('eul_msg16'));
          return;
        }

        this.$http.post(this.$host+'/api/KAKAOupload',{
          JSONVALUE: escape(JSON.stringify(vlist))
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('eul_msg17'));

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eul_msg18'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });


      },


      //LMS 발송
      sendLMS(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        if(this.selectList.length == 0){
          this.$alert(this.$t('eul_msg114'));
          return;
        }

        this.$confirm(this.$t('eul_msg115'))
        .then(() => {
          
          //!element.TEL.replace(/-/g,"").startsWith("010")
          
          const vlist = [];
          this.selectList.forEach(element=>{
            if( element.TEL == null || element.TEL == undefined || element.TEL.length < 1 ){
                return; //continue
            }
            vlist.push(element.IDX);
          });

          this.sendLMSAalimTalk(vlist);

        });        

      },
      

      sendLMSAalimTalk(vlist){

        if(vlist.length == 0){
          this.$alert(this.$t('eul_msg116'));
          return;
        }

        this.$http.post(this.$host+'/api/AlimLMSupload',{
          JSONVALUE: escape(JSON.stringify(vlist))
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('eul_msg17'));

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eul_msg18'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });


      },



      //명찰출력 테스트
      printtest(istest){

        if(this.SEARCH_COM_IDX == null || this.SEARCH_COM_IDX == undefined || this.SEARCH_COM_IDX == ''){
          this.$alert(this.$t('common_select_com'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null || this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == ''){
          this.$alert(this.$t('common_select_event'));
          return;
        }

        
        if(this.selectList.length == 0){
          this.$alert(this.$t('eul_msg19'));
          return;
        }
        
        if(istest == 0){
          this.$confirm(this.$t('eul_msg20'))
          .then(() => {
            //2. 선택된 행사의 모든 이벤트 옵션의 행사 디자인을 가져와야한다.
            this.getEventDesignAll(istest);
          });
        }else if(istest == 1){
          this.$confirm(this.$t('eul_msg21'))
          .then(() => {
            //2. 선택된 행사의 모든 이벤트 옵션의 행사 디자인을 가져와야한다.
            this.getEventDesignAll(istest);
          });
        }

      },

      changeoption(){

        if(this.SEARCH_COM_IDX == null || this.SEARCH_COM_IDX == undefined){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null || this.SEARCH_EVENT_IDX == undefined){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        if(this.selectList.length  == 0){
          this.$alert(this.$t('eul_msg23'));
          return;
        }

        this.EDIT_OPTION_IDX = null;
        this.option_dialog = true;

      },

      changeoptionrun(){

        if(this.EDIT_OPTION_IDX == null || this.EDIT_OPTION_IDX == undefined){
          this.$alert(this.$t('eul_msg24'));
          return;
        }
        
        this.$confirm(this.$t('eul_msg25'))
        .then(() => {
          var uploaditem = [];
          this.selectList.forEach(item=>{
            uploaditem.push({VISITOR_IDX:item.IDX, EVENT_IDX:item.EVENT_IDX, ADMIN_IDX:item.ADMIN_IDX, OPTION_IDX:this.EDIT_OPTION_IDX});
          });

          //서버로 전송해서 처리
          this.$http.post(this.$host+'/api/VisitorOptionUpdateAll',{
              JSONVALUE: escape(JSON.stringify(uploaditem))
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.option_dialog = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('eul_msg26')).then(()=>{
                this.page = 0;
                this.loadpage(1);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('eul_msg27'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.option_dialog = false;
            this.$alert(this.$t('eul_msg27'));
          });

        });

      },

      
      /* 
      testprint(){

        //프린트를 취소해도 afterprint가 호출된다.

        const top_div = document.createElement("div");
        top_div.textContent = "하하하";
        var printContents = top_div.outerHTML;
        var w = window.open();
        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); }; window.onafterprint=function(){ alert("123"); } ' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();
        

      },      
      */


      //연속출력 테스트중 - C4040프린터, 384x463 사이즈 명찰, start 2mm, cut 2.5mm
      async createTicket4040(){

        //1. 행사별 맵핑정보 양식 => infoItem
        //2. 행사별 명찰디자인    => designList 
        const top_div = document.createElement("div");

        //var toppos = 0;

        //선택 순서가 꼬이기 때문에 여기서 선택한 순서대로 리스트를 새로 만듬.
        const seqList = [];
        if(this.selectList.length > 1){
          for(let i=0;i<this.itemList.length;i++){
            for(let j=0;j<this.selectList.length;j++){
              if(this.itemList[i].IDX == this.selectList[j].IDX){
                seqList.push(this.itemList[i]);
                continue;
              }
            }
          }
        }else{
          seqList.push(this.selectList[0]);
        }


        //500개 테스트
        /*
        for(var temp=0;temp<=300;temp++){
          seqList.push(this.selectList[0]);
        }
        */

        var size_flag = false;
        for(var i=0;i<seqList.length;i++){

          const user = seqList[i];

          //해당 참가자의 입장료 옵션에 해당하는 명찰디자인 가져오기
          const SELECT_DESIGN = this.designList.get(user.OPTION_IDX);
          const temp1 = document.createElement("div");

          
          const width_mm  = this.getPrintWidth(SELECT_DESIGN.COMPONENT_WIDTH);
          const height_mm = this.getPrintHeight(SELECT_DESIGN.COMPONENT_HEIGHT);
          if(width_mm == 0 || height_mm == 0){
            size_flag = true;
            break;
          }
          
          //temp1.style.height    = this.pxTomm(SELECT_DESIGN.COMPONENT_HEIGHT)+"mm";
          //temp1.style.width     = this.pxTomm(SELECT_DESIGN.COMPONENT_WIDTH)+"mm";

          //temp1.style.height    = "122.5mm";
          //temp1.style.width     = "102mm";

          temp1.style.height   = `${height_mm}mm`;
          temp1.style.width    = `${width_mm}mm`;

          temp1.style.overflow  = "hidden";

          //temp1.style.marginLeft = "0.5mm";
          //temp1.style.marginLeft    = "auto";
          //temp1.style.marginRight   = "auto";
          //temp1.style.marginTop     = "2mm";
          
        
          //temp1.style.marginBottom  = "auto";

          const temp2 = document.createElement("div");
          
          //temp2.style.height    = this.pxTomm(SELECT_DESIGN.COMPONENT_HEIGHT)+"mm";
          //temp2.style.width     = this.pxTomm(SELECT_DESIGN.COMPONENT_WIDTH)+"mm";

          temp2.style.height   = `${height_mm}mm`;
          temp2.style.width    = `${width_mm}mm`;

          //temp2.style.height    = "122.5mm";
          //temp2.style.width     = "102mm";
          temp2.style.overflow  = "hidden";

          //temp2.style.marginLeft    = "0.5mm";
          //temp2.style.marginRight   = "auto";
          //temp2.style.marginTop     = "0.5mm";
          //temp2.style.marginBottom  = "auto";
          if(this.print_type == "basic"){
            temp2.style.transform  = "rotate(180deg)";
          }

          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = SELECT_DESIGN.COMPONENT_WIDTH;
          bg.LAYOUT_HEIGHT  = SELECT_DESIGN.COMPONENT_HEIGHT;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.COMPONENT_TYPE = 0; 
          bg.BGTYPE = 0;
          bg.BGCOLOR = "FFFFFFFF";
          
          var front  = new DRBackground(bg, {}, this, true);
          var back   = new DRBackground(bg, {}, this, false);
          temp1.appendChild(front.back_div);
          temp2.appendChild(back.back_div);        

          const matchinfo = [];
          matchinfo.push({name:'직접입력'});
          matchinfo.push({name:user.INFO1});
          matchinfo.push({name:user.INFO2});
          matchinfo.push({name:user.INFO3});
          matchinfo.push({name:user.INFO4});
          matchinfo.push({name:user.INFO5});
          matchinfo.push({name:user.INFO6});
          matchinfo.push({name:user.INFO7});
          matchinfo.push({name:user.INFO8});
          matchinfo.push({name:user.INFO9});
          matchinfo.push({name:user.INFO10});
          matchinfo.push({name:user.INFO11});
          matchinfo.push({name:user.INFO12});
          matchinfo.push({name:user.INFO13});
          matchinfo.push({name:user.INFO14});
          matchinfo.push({name:user.INFO15});
          matchinfo.push({name:user.INFO16});
          matchinfo.push({name:user.INFO17});
          matchinfo.push({name:user.INFO18});
          matchinfo.push({name:user.INFO19});
          matchinfo.push({name:user.INFO20});
          matchinfo.push({name:user.IDX});

          await this.createPrintComponent(front, SELECT_DESIGN.COMPONENT.data, matchinfo);
          await this.createPrintComponent(back, SELECT_DESIGN.COMPONENT2.data, matchinfo);

          
          //하나의 명찰
          const page_div = document.createElement("div");
          page_div.style.height         = "100%";
          page_div.style.display        = "flex";
          page_div.style.flexDirection  = "column";
          page_div.style.justifyContent = "center";
          page_div.style.alignItems     = "center";
          page_div.style.overflow       = "hidden";

          page_div.style.pageBreakAfter = "always";
          //page_div.style.border         = "black 1px solid";
          //page_div.style.marginTop      = "-2px";

          //page_div.style.position  = "absolute";
          //page_div.style.height    = ((SELECT_DESIGN.COMPONENT_HEIGHT*2)+12)+"px";
          //page_div.style.width     = SELECT_DESIGN.COMPONENT_WIDTH+"px";
          //page_div.style.left      = "0px";
          //page_div.style.top       = "0px";
          //page_div.style.top       = toppos + "px";
          //page_div.style.overflow  = "hidden";

          page_div.appendChild(temp1);
          page_div.appendChild(temp2);
          
          top_div.appendChild(page_div);
          //toppos += 917;  //이렇게 줘야 연속출력잘됨.

        }

        //지원하지 않는 명찰사이즈 체크
        if(size_flag){
          this.$alert(this.$t("common_size"));
          return;
        }
        

        var printContents = top_div.outerHTML;
        

        var w = window.open();

        document.fonts.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });

        //폰트정보 넘겨주기
        /*
        this.fontList.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });
        this.comfontList.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });
        */

        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); };' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact; margin:0px;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();
      },      

      getPrintWidth(wpx){
        if(wpx == 384){
          return 102;
        }else if(wpx == 264){
          return 70;
        }else if(wpx == 340){
          return 90;
        }else if(wpx == 793){
          return 210;
        }else{
          return 0;
        }
      },

      getPrintHeight(hpx){
        if(hpx == 603){
          return 160;
        }else if(hpx == 567){
          return 150;
        }else if(hpx == 463){
          return 122.5;
        }else if(hpx == 384){
          return 102;
        }else if(hpx == 313){
          return 83;
        }else if(hpx == 263){
          return 70;
        }else if(hpx == 190){
          return 50;
        }else if(hpx == 191){
          return 83;
        }else if(hpx == 642){
          return 170;
        }else if(hpx == 510){
          return 135;

        }else{
          return 0;
        }
      },

      pxTomm(px){
          return (px * 0.2645833333).toFixed(5);
      },

      //기존 c3500출력
      async createTicket3500(){

        //1. 행사별 맵핑정보 양식 => infoItem
        //2. 행사별 명찰디자인    => designList 
        const top_div = document.createElement("div");
        var toppos = 0;

        //선택 순서가 꼬이기 때문에 여기서 선택한 순서대로 리스트를 새로 만듬.
        const seqList = [];
        if(this.selectList.length > 1){
          for(let i=0;i<this.itemList.length;i++){
            for(let j=0;j<this.selectList.length;j++){
              if(this.itemList[i].IDX == this.selectList[j].IDX){
                seqList.push(this.itemList[i]);
                continue;
              }
            }
          }
        }else{
          seqList.push(this.selectList[0]);
        }

        for(var i=0;i<seqList.length;i++){

          const user = seqList[i];

          //해당 참가자의 입장료 옵션에 해당하는 명찰디자인 가져오기
          const SELECT_DESIGN = this.designList.get(user.OPTION_IDX);
          
          const temp1 = document.createElement("div");
          const temp2 = document.createElement("div");
          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = SELECT_DESIGN.COMPONENT_WIDTH;
          bg.LAYOUT_HEIGHT  = SELECT_DESIGN.COMPONENT_HEIGHT;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.COMPONENT_TYPE = 0; 
          bg.BGTYPE = 0;
          bg.BGCOLOR = "FFFFFFFF";
          
          var front  = new DRBackground(bg, {}, this, true);
          var back   = new DRBackground(bg, {}, this, false);
          temp1.appendChild(front.back_div);
          temp2.appendChild(back.back_div);        

          const matchinfo = [];
          matchinfo.push({name:this.$t('eul_msg28')});
          matchinfo.push({name:user.INFO1});
          matchinfo.push({name:user.INFO2});
          matchinfo.push({name:user.INFO3});
          matchinfo.push({name:user.INFO4});
          matchinfo.push({name:user.INFO5});
          matchinfo.push({name:user.INFO6});
          matchinfo.push({name:user.INFO7});
          matchinfo.push({name:user.INFO8});
          matchinfo.push({name:user.INFO9});
          matchinfo.push({name:user.INFO10});
          matchinfo.push({name:user.INFO11});
          matchinfo.push({name:user.INFO12});
          matchinfo.push({name:user.INFO13});
          matchinfo.push({name:user.INFO14});
          matchinfo.push({name:user.INFO15});
          matchinfo.push({name:user.INFO16});
          matchinfo.push({name:user.INFO17});
          matchinfo.push({name:user.INFO18});
          matchinfo.push({name:user.INFO19});
          matchinfo.push({name:user.INFO20});
          matchinfo.push({name:user.IDX});    //이게 QR 21번.

          await this.createPrintComponent(front, SELECT_DESIGN.COMPONENT.data, matchinfo);
          await this.createPrintComponent(back, SELECT_DESIGN.COMPONENT2.data, matchinfo);

          temp2.style.position  = "absolute";
          temp2.style.height    = SELECT_DESIGN.COMPONENT_HEIGHT+"px";
          temp2.style.width     = SELECT_DESIGN.COMPONENT_WIDTH+"px";
          temp2.style.left      = "0px";
          temp2.style.top       = SELECT_DESIGN.COMPONENT_HEIGHT+"px";
          temp2.style.transform = "rotate(180deg)";
          
          //하나의 명찰
          const page_div = document.createElement("div");
          page_div.style.position  = "absolute";
          page_div.style.height    = ((SELECT_DESIGN.COMPONENT_HEIGHT*2)+12)+"px";
          page_div.style.width     = SELECT_DESIGN.COMPONENT_WIDTH+"px";
          page_div.style.left      = "0px";
          //page_div.style.top       = "0px";
          page_div.style.top       = toppos + "px";
          //page_div.style.overflow  = "hidden";

          page_div.appendChild(temp1);
          page_div.appendChild(temp2);
          
          top_div.appendChild(page_div);
          toppos += 917;  //이렇게 줘야 연속출력잘됨.

        }

        var printContents = top_div.outerHTML;
        

        var w = window.open();

        document.fonts.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });

        //폰트정보 넘겨주기
        /*
        this.fontList.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });
        this.comfontList.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });
        */

        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); };' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();
        

      },      

      //컴포넌트 생성 (명찰 정보를 가지고 명찰생성)
      async createPrintComponent(bg, list, matchinfo){
        
        //컴포넌트 생성
        for(var i=0;i<list.length;i++){
        
          const element = list[i];

          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);
          model.ROTATE        = element.ROTATE || 0;

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX         = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;

          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              continue;
            }else{
              model.ISBG = 0;
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              }
            } 
          }

          //텍스트 타입이면 텍스트 사이즈를 동적으로 처리해줘야한다.
          if(element.COMPONENT_TYPE == 1){
            var contenttext = "";
            if(model.TEXTMATCH == "INPUT"){
              contenttext     = model.TEXTVALUE;
            }else if(model.TEXTMATCH == "1"){
              contenttext     = matchinfo[1].name;
            }else if(model.TEXTMATCH == "2"){
              contenttext     = matchinfo[2].name;
            }else if(model.TEXTMATCH == "3"){
              contenttext     = matchinfo[3].name;
            }else if(model.TEXTMATCH == "4"){
              contenttext     = matchinfo[4].name;
            }else if(model.TEXTMATCH == "5"){
              contenttext     = matchinfo[5].name;
            }else if(model.TEXTMATCH == "6"){
              contenttext     = matchinfo[6].name;
            }else if(model.TEXTMATCH == "7"){
              contenttext     = matchinfo[7].name;
            }else if(model.TEXTMATCH == "8"){
              contenttext     = matchinfo[8].name;
            }else if(model.TEXTMATCH == "9"){
              contenttext     = matchinfo[9].name;
            }else if(model.TEXTMATCH == "10"){
              contenttext     = matchinfo[10].name;
            }else if(model.TEXTMATCH == "11"){
              contenttext     = matchinfo[11].name;
            }else if(model.TEXTMATCH == "12"){
              contenttext     = matchinfo[12].name;
            }else if(model.TEXTMATCH == "13"){
              contenttext     = matchinfo[13].name;
            }else if(model.TEXTMATCH == "14"){
              contenttext     = matchinfo[14].name;
            }else if(model.TEXTMATCH == "15"){
              contenttext     = matchinfo[15].name;
            }else if(model.TEXTMATCH == "16"){
              contenttext     = matchinfo[16].name;
            }else if(model.TEXTMATCH == "17"){
              contenttext     = matchinfo[17].name;
            }else if(model.TEXTMATCH == "18"){
              contenttext     = matchinfo[18].name;
            }else if(model.TEXTMATCH == "19"){
              contenttext     = matchinfo[19].name;
            }else if(model.TEXTMATCH == "20"){
              contenttext     = matchinfo[20].name;

            }else{
              contenttext     = ""; 
            }            

            //폰트 사이즈 동적 조절
            var strs = contenttext.split("\n");
            var adjust_size = 1;
            var text_size = parseInt(model.TEXTSIZE);
            if(strs.length <= 1){
              //한줄
              var rendersize = calculateSize(contenttext, {font:model.TEXTFONT, fontSize:model.TEXTSIZE+"px"});
              if(rendersize.width+10 >= model.LAYOUT_WIDTH){
                //컨텐츠가 영역을 넘어가면 폰트사이즈 조절 진입
                while(parseInt(rendersize.width+10) >= model.LAYOUT_WIDTH && text_size > 1){
                  text_size = parseInt(model.TEXTSIZE - adjust_size);
                  rendersize = calculateSize(contenttext, {font:model.TEXTFONT, fontSize:text_size+'px'});
                  adjust_size++;
                }
                model.TEXTSIZE = parseInt(text_size);
              }
            }else{

              //두줄
              var rendersize1 = calculateSize(strs[0], {font:model.TEXTFONT, fontSize:model.TEXTSIZE+"px", lineHeight:"120%"});
              var rendersize2 = calculateSize(strs[1], {font:model.TEXTFONT, fontSize:model.TEXTSIZE+"px", lineHeight:"120%"});

              if(Math.max(rendersize1.width,rendersize2.width)+10 >= model.LAYOUT_WIDTH 
              || rendersize1.height + rendersize2.height + 10 >= model.LAYOUT_HEIGHT
              ){
                //컨텐츠가 영역을 넘어가면 폰트사이즈 조절 진입
                while( (parseInt(Math.max(rendersize1.width,rendersize2.width)+10) >= model.LAYOUT_WIDTH || parseInt(rendersize1.height+rendersize2.height+4) >= model.LAYOUT_HEIGHT) && text_size > 1){
                  text_size = parseInt(model.TEXTSIZE - adjust_size);
                  rendersize1 = calculateSize(strs[0], {font:model.TEXTFONT, fontSize:text_size+'px', lineHeight:"120%"});
                  rendersize2 = calculateSize(strs[1], {font:model.TEXTFONT, fontSize:text_size+'px', lineHeight:"120%"});
                  adjust_size++;
                }
                model.TEXTSIZE = parseInt(text_size);
              }
            }
            
          }

          if(element.ISBG == 1){
              bg.updateBackground(model);
              continue;
          }

          //컴포넌트 생성.
          //MATCHTYPELIST가 매핑정보다. 명찰의 특정 텍스트 영역에 3번 코드가 매핑되야 한다고 되어있으면 디자인 시에는 
          //3번에 해당하는 영어이름을 넣으라는 정보가 필요했지만 여기서는 실제 영어이름 정보를 매핑해야한다.
          const component = new DRComponent(model, matchinfo, true);
          //컴포넌트가 QR이면 동적으로 생성해줘야한다. 동기방식으로 기다려줘야한다. 생성시 딜레이
          if(model.COMPONENT_TYPE == 2){
            await component.createQRCODE(component);
          }else if(model.COMPONENT_TYPE == 3){
            var photourl = "";
            if(model.TEXTMATCH == "INPUT"){
              photourl     = model.TEXTVALUE;
            }else if(model.TEXTMATCH == "1"){
              photourl     = matchinfo[1].name;
            }else if(model.TEXTMATCH == "2"){
              photourl     = matchinfo[2].name;
            }else if(model.TEXTMATCH == "3"){
              photourl     = matchinfo[3].name;
            }else if(model.TEXTMATCH == "4"){
              photourl     = matchinfo[4].name;
            }else if(model.TEXTMATCH == "5"){
              photourl     = matchinfo[5].name;
            }else if(model.TEXTMATCH == "6"){
              photourl     = matchinfo[6].name;
            }else if(model.TEXTMATCH == "7"){
              photourl     = matchinfo[7].name;
            }else if(model.TEXTMATCH == "8"){
              photourl     = matchinfo[8].name;
            }else if(model.TEXTMATCH == "9"){
              photourl     = matchinfo[9].name;
            }else if(model.TEXTMATCH == "10"){
              photourl     = matchinfo[10].name;
            }else if(model.TEXTMATCH == "11"){
              photourl     = matchinfo[11].name;
            }else if(model.TEXTMATCH == "12"){
              photourl     = matchinfo[12].name;
            }else if(model.TEXTMATCH == "13"){
              photourl     = matchinfo[13].name;
            }else if(model.TEXTMATCH == "14"){
              photourl     = matchinfo[14].name;
            }else if(model.TEXTMATCH == "15"){
              photourl     = matchinfo[15].name;
            }else if(model.TEXTMATCH == "16"){
              photourl     = matchinfo[16].name;
            }else if(model.TEXTMATCH == "17"){
              photourl     = matchinfo[17].name;
            }else if(model.TEXTMATCH == "18"){
              photourl     = matchinfo[18].name;
            }else if(model.TEXTMATCH == "19"){
              photourl     = matchinfo[19].name;
            }else if(model.TEXTMATCH == "20"){
              photourl     = matchinfo[20].name;
            }else{
              photourl     = ""; 
            }            
            await component.createPHOTO(component, photourl);
          }else if(model.COMPONENT_TYPE == 4){
            var barcodevalue = "";
            if(model.TEXTMATCH == "INPUT"){
              barcodevalue     = model.TEXTVALUE;
            }else if(model.TEXTMATCH == "1"){
              barcodevalue     = matchinfo[1].name;
            }else if(model.TEXTMATCH == "2"){
              barcodevalue     = matchinfo[2].name;
            }else if(model.TEXTMATCH == "3"){
              barcodevalue     = matchinfo[3].name;
            }else if(model.TEXTMATCH == "4"){
              barcodevalue     = matchinfo[4].name;
            }else if(model.TEXTMATCH == "5"){
              barcodevalue     = matchinfo[5].name;
            }else if(model.TEXTMATCH == "6"){
              barcodevalue     = matchinfo[6].name;
            }else if(model.TEXTMATCH == "7"){
              barcodevalue     = matchinfo[7].name;
            }else if(model.TEXTMATCH == "8"){
              barcodevalue     = matchinfo[8].name;
            }else if(model.TEXTMATCH == "9"){
              barcodevalue     = matchinfo[9].name;
            }else if(model.TEXTMATCH == "10"){
              barcodevalue     = matchinfo[10].name;
            }else if(model.TEXTMATCH == "11"){
              barcodevalue     = matchinfo[11].name;
            }else if(model.TEXTMATCH == "12"){
              barcodevalue     = matchinfo[12].name;
            }else if(model.TEXTMATCH == "13"){
              barcodevalue     = matchinfo[13].name;
            }else if(model.TEXTMATCH == "14"){
              barcodevalue     = matchinfo[14].name;
            }else if(model.TEXTMATCH == "15"){
              barcodevalue     = matchinfo[15].name;
            }else if(model.TEXTMATCH == "16"){
              barcodevalue     = matchinfo[16].name;
            }else if(model.TEXTMATCH == "17"){
              barcodevalue     = matchinfo[17].name;
            }else if(model.TEXTMATCH == "18"){
              barcodevalue     = matchinfo[18].name;
            }else if(model.TEXTMATCH == "19"){
              barcodevalue     = matchinfo[19].name;
            }else if(model.TEXTMATCH == "20"){
              barcodevalue     = matchinfo[20].name;
            }else{
              barcodevalue     = ""; 
            }            
            await component.createBARCODE(component, barcodevalue);            
          }
          
          bg.addComponent(component, false);

        }

      },
      

      getEventDesignAll(istest){
        
        const selectEvent = new Map();
        this.selectList.forEach(item=>{
          selectEvent.set(item.OPTION_IDX, item.OPTION_IDX);
        });
        const select_option_idxs = Array.from(selectEvent.keys());
        
                    
        //선택된 행사의 모든 명찰디자인 가져오기
        this.$http.post(this.$host+'/api/GuestDesignAll',
          {
              ADMIN_IDX : this.$session.get("ADMIN_IDX")
            , OPTION_IDX : select_option_idxs
            , EVENT_IDX : this.SEARCH_EVENT_IDX
            , COM_IDX : this.SEARCH_COM_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){
            
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            const list = result.data.resultData;
            
            this.comfontList.clear();   //읽어야 하는 폰트 리스트 초기화
            this.designList.clear();
            list.forEach(element => {
                
                var tempobj   = JSON.parse(JSON.stringify(element)); //파싱
                
                //명찰에 사용된 폰트정보 가져오기
                tempobj.COMPONENT.data.forEach(cp=>{
                  const font = this.fontList.find(ft => ft.CODE === cp.TEXTFONT );
                  var temp_font = new FontFace(font.CODE, "url('"+font.FONTURL+"') format('truetype')");
                  if(!this.comfontList.has(font.CODE)){
                    document.fonts.add(temp_font);
                    this.comfontList.set(font.CODE, temp_font);
                  }
                });
                tempobj.COMPONENT2.data.forEach(cp=>{
                  const font = this.fontList.find(ft => ft.CODE === cp.TEXTFONT );
                  var temp_font = new FontFace(font.CODE, "url('"+font.FONTURL+"') format('truetype')");
                  if(!this.comfontList.has(font.CODE)){
                    document.fonts.add(temp_font);
                    this.comfontList.set(font.CODE, temp_font);
                  }
                });

                this.designList.set(tempobj.OPTION_IDX, tempobj);
            });
            
            //업체폰트 정보
            const flist = result.data.fontData;
            
            //폰트 로드처리
            flist.forEach(element => {
              const font = this.fontList.find(ft => ft.CODE === element.NAME );
              var temp_font = new FontFace(font.CODE, "url('"+font.FONTURL+"') format('truetype')");
              if(!this.comfontList.has(font.CODE)){
                document.fonts.add(temp_font);
                this.comfontList.set(font.CODE, temp_font);
              }
            });

            
            
            if(this.comfontList.size > 0){
              const tempfontlist = Array.from(this.comfontList.values());
              Promise.all(tempfontlist.map(this.observeFontLoad))
              .then(() => {
                  
                  if(istest == 0){
                    //명찰출력
                    this.insertPrintInfo();
                  }else if(istest == 1){
                    //테스트출력 (통계안잡음)
                    this.createTicket4040();
                  }
              })
              // eslint-disable-next-line no-unused-vars
              .catch(error => {
                  
                  if(istest == 0){
                    //명찰출력
                    this.insertPrintInfo();
                  }else if(istest == 1){
                    //테스트출력 (통계안잡음)
                    this.createTicket4040();
                  }
              })
            }else{
              //로드할께 없으면
              
              if(istest == 0){
                //명찰출력
                this.insertPrintInfo();
              }else if(istest == 1){
                //테스트출력 (통계안잡음)
                this.createTicket4040();
              }
            }

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }

          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.$alert(this.$t('eul_msg29'));
          });

      },

      //프린트 정보 추가
      insertPrintInfo(){
          
        this.$http.post(this.$host+'/api/VPrintInsertList',
          {
            SELECTDATA: escape(JSON.stringify(this.selectList))
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //4. 선택 참가자의 명찰을 그리고 출력한다.
            this.createTicket4040();

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eul_msg30'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.$alert(this.$t('eul_msg30'));
        });
        
      },    

      
      newexcelinsert(){
        this.uploadFile = null;
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.excelItem = Object.assign({}, this.defaultItem)
        this.excelItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.excelItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.excelItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.excelItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.excel_dialog = true;
      },      

      excelupdate(){
        this.uploadFile = null;
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.excelItem = Object.assign({}, this.defaultItem)
        this.excelItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.excelItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.excelItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.excelItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.excelupdate_dialog = true;
      },            

      //대량등록 양식 다운로드 
      downloadExcel(){
        this.$confirm(this.$t('eul_msg31')).then(() => {

            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t('common_select_tevent'));
              return;
            }

            //동적 헤더
            const headers = [];
            headers.push(this.$t('eul_excel32'));
            headers.push(this.$t('eul_excel44'));

            for(var k=0;k<this.infoItem.length;k++){
              if(this.infoItem[k].USETYPE == 1) headers.push(this.getColumnName(this.infoItem[k]));
            }

            headers.push(this.$t('eul_msg32'));
            headers.push(this.$t('eul_msg33'));
            headers.push(this.$t('eul_msg34'));
            headers.push(this.$t('eul_msg35'));

            if(this.useInfo.USESEX == 1)  headers.push(this.$t('eul_msg36'));
            if(this.useInfo.USEYEAR == 1) headers.push(this.$t('eul_msg37'));
            if(this.useInfo.USEPW == 1)   headers.push(this.$t('eul_msg38'));
            
            headers.push(this.$t('eul_msg39'));
            headers.push(this.$t('eul_msg40'));
            headers.push(this.$t('eul_msg102'));

            if(this.useInfo.PART_TYPE == 1){
              headers.push(this.$t('eventplace_excel10'));
              headers.push(this.$t('eventplace_excel11'));
              headers.push(this.$t('eventplace_excel12'));
              headers.push(this.$t('eventplace_excel13'));
              headers.push(this.$t('eventplace_excel14'));
              headers.push(this.$t('eventplace_excel15'));
              headers.push(this.$t('eventplace_excel16'));
              headers.push(this.$t('eventplace_excel17'));
              headers.push(this.$t('eventplace_excel18'));
              headers.push(this.$t('eventplace_excel19'));
            }

            // 2. 데이터 영역 생성 (빈 행 1,000개)
            // Array.fill을 사용하여 빈 배열 1,000개를 만듭니다.
            const data = [headers, ...Array(1000).fill(Array(headers.length).fill(""))];   
            
            // 3. 시트 생성
            // aoa_to_sheet는 '배열의 배열' 형태로 시트를 만듭니다.
            const item_sheet = XLSX.utils.aoa_to_sheet(data);            

            // 4. 모든 셀 서식을 텍스트로 강제 지정
            Object.keys(item_sheet).forEach(cell => {
              if (cell.startsWith('!')) return; // 메타 정보 제외
              item_sheet[cell].t = 's'; // 타입을 String으로 고정
              item_sheet[cell].z = '@'; // 서식을 텍스트로 고정 (010 방지)
            });            

            //모든 셀을 스트링 서식으로 강제 지정
            Object.keys(item_sheet).forEach(cell => {
              if (cell.startsWith('!')) return; // 시트 메타데이터 무시
              item_sheet[cell].t = 's'; // 타입을 String으로 고정
              item_sheet[cell].z = '@'; // 서식을 텍스트로 고정 (010 방지)
              // 4. 스타일 지정 (폰트 사이즈 10, 가운데 정렬)
              item_sheet[cell].s = {
                font: { sz: 10 },
                alignment: { horizontal: 'center', vertical: 'center' }
              };
            });                

            // 헤더 스타일 적용 (배경: 남색, 글씨: 흰색, 폰트 사이즈 10, 가운데 정렬)
            for (let i = 0; i < headers.length; i++) {
              const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
              if (item_sheet[cellRef]) {
                item_sheet[cellRef].s = {
                  font: { sz: 10, bold: true, color: { rgb: "FFFFFF" } },
                  fill: { fgColor: { rgb: "366092" } },
                  alignment: { horizontal: 'center', vertical: 'center' }
                };
              }
            }

            // 데이터 셀 스타일 적용 (폰트 사이즈 10, 가운데 정렬, 첫번째 열은 볼드)
            const range = XLSX.utils.decode_range(item_sheet['!ref']);
            for (let R = 1; R <= range.e.r; R++) {
              for (let C = 0; C <= range.e.c; C++) {
                const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                if (item_sheet[cellRef]) {
                  item_sheet[cellRef].s = {
                    font: { sz: 10, bold: C === 0 },
                    alignment: { horizontal: 'center', vertical: 'center' }
                  };
                }
              }
            }

            // 5. 컬럼 너비 자동 계산 적용 (이전 답변 드린 로직 활용)
            const wscols = headers.map(h => ({
              wch: Math.max(this.getByteLength(h) + 2, 15) // 최소 너비 15 보장
            }));
            item_sheet['!cols'] = wscols;   

            // 첫번째 행(헤더) 높이 설정
            item_sheet['!rows'] = [{ hpt: 25 }];

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('eul_msg41'));
            XLSX.writeFile(wb, this.SEARCH_EVENT_NAME+this.$t('eul_msg42'));

        });
      },

      // 한글 바이트 계산 보조 함수
      getByteLength(str) {
        if (!str) return 0;
        let len = 0;
        for (let i = 0; i < str.length; i++) {
          len += (escape(str.charAt(i)).length > 4) ? 2 : 1;
        }
        return len;
      },

      getColumnName(item){
        var temp = "";
        if(item.USETYPE == 0){
          temp = this.$t('eul_msg43');
          return temp;
        }else{
          if(this.$i18n.locale == 'ko'){
            temp = item.NAME;
          }else{
            temp = item.ENAME;
          }
        }

        if(item.REQTYPE == 1){
          temp = "*"+temp;
        }
        
        if(item.LANTYPE == 2){
          temp += this.$t('eul_msg44');
        }
        return temp;
      },



      uploadExcel(){
        
        const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

        if(this.uploadFile == null){
          this.$alert(this.$t('eul_msg46'));
          return;
        }
        this.$confirm(this.$t('eul_msg47')).then(() => {
          
          this.excel_prog = true;
          const reader = new FileReader();
          
          reader.onload = ()=>{
            var fileData = reader.result;
            let workbook = XLSX.read(fileData, {type : 'binary'});  
            var sheetNameList = workbook.SheetNames; // 시트 이름 목록 가져오기 
            var firstSheetName = sheetNameList[0]; // 첫번째 시트명            
            var firstSheet = workbook.Sheets[firstSheetName]; // 첫번째 시트 
            let wrokjson = XLSX.utils.sheet_to_json(firstSheet, {defval:""});

            //빈값 제거
            var uploaditem = wrokjson.filter(row => 
              Object.values(row).some(val => String(val).trim() !== "")
            );            

            if(uploaditem.length < 1){
              this.$alert(this.$t('eul_msg48'));
              this.excel_prog = false;
              return;
            }

            //데이터 검증 
            var checkflag = true;
            var read_column = Object.keys(wrokjson[0]);
            
            const requiredColumns = [];
            for (let k = 0; k < this.infoItem.length; k++) {
              if (this.infoItem[k].USETYPE == 1) {
                requiredColumns.push({
                    db_idx: k+1,
                    excel_name: this.getColumnName(this.infoItem[k])
                });
              }
            }            

            // 3. 검증 로직: 요구되는 모든 컬럼이 엑셀에 존재하는가?
            const missingColumns = requiredColumns.filter(col => !read_column.includes(col.excel_name));
            if (missingColumns.length > 0) {
              console.log("누락된 컬럼:", missingColumns);
              checkflag = false;
            }
            if(!checkflag){
              this.$alert(this.$t('eul_msg49'));
              this.excel_prog = false;
              return;
            }

            //등록카테고리 값 검증을 위한 IDX 값.
            const idxValues = this.optionItem.map(item => String(item.IDX));

            for(var i=0;i<uploaditem.length;i++){
              if(!checkflag){
                break;
              }
              var element = uploaditem[i];

              //등록카테고리가 엉뚱한 값이 있는지 체크
              if(!idxValues.includes( String(element[this.$t('eul_excel32')]))){
                //엉뚱한 값
                this.$alert(i+1+this.$t('eul_msg111'));
                checkflag = false;
                return;
              }

              if(element[this.$t('eul_excel44')] == null || String(this.$t('eul_excel44')).length < 1){
                this.$alert(i+1+this.$t('eul_msg112'));
                checkflag = false;
                return;
              }

              //기본등록양식 검증
              for(var j=0;j<this.infoItem.length;j++){

                var column_name = this.getColumnName(this.infoItem[j])

                if(this.infoItem[j].USETYPE == 0 || this.infoItem[j].SHOWTYPE == 0){
                  //사용안함이면 검증 패스
                  continue;
                }
                if(this.infoItem[j].REQTYPE == 1){  //필수입력
                  if(element[column_name] == null || String(element[column_name]).length < 1){
                    this.$alert(i+1+this.$t('eul_msg50') + column_name+this.$t('eul_msg51'));
                    checkflag = false;
                    break;
                  }
                }
                if(this.infoItem[j].LANTYPE == 2){
                  //영문만 사용 가능한 경우
                  if(korean.test(element[column_name])){
                    this.$alert(i+1+this.$t('eul_msg50')+column_name+this.$t('eul_msg52'));
                    checkflag = false;
                    break;
                  }
                }

                if(element[column_name] != null && String(element[column_name]).length >= 200){
                  this.$alert(i+1+this.$t('eul_msg50')+column_name+this.$t('eul_msg53'));
                  checkflag = false;
                  break;
                }

              } //기본등록양식 검증 완료


              //기본정보 체크
              if(this.useInfo.USETEL == 1 && (element[this.$t('eul_msg34')] == null || String(element[this.$t('eul_msg34')]).length < 1) ){
                this.$alert(i+1+this.$t('eul_msg54'));
                checkflag = false;
                break;
              }

              const mobileVal1 = /[^0-9-]/g;
              if(this.useInfo.USETEL == 1 && mobileVal1.test( String(element[this.$t('eul_msg34')]).trim() )){
                this.$alert(i+1+this.$t('eul_msg55'));
                checkflag = false;
                return;
              } 
              if(this.useInfo.USETEL == 1 && (element[this.$t('eul_msg34')] != null && String(element[this.$t('eul_msg34')]).length >= 40) ){
                this.$alert(i+1+this.$t('eul_msg56'));
                checkflag = false;
                break;
              }

              if(element[this.$t('eul_msg32')] != null && String(this.$t('eul_msg32')).length >= 500){
                this.$alert(i+1+this.$t('eul_msg57'));
                checkflag = false;
                break;
              }

              if(this.useInfo.USEMAIL == 1 && (element[this.$t('eul_msg35')] == null || String(element[this.$t('eul_msg35')]).length < 1) ){
                this.$alert(i+1+this.$t('eul_msg58'));
                checkflag = false;
                break;
              }

              //var emailVal = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
              //var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[-_.0-9a-zA-Z][-_.0-9a-zA-Z]*.[a-zA-Z]{2,3}$/i;
              var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[0-9a-zA-Z][-_.0-9a-zA-Z]*(\.[a-zA-Z]{2,})+$/i;
              
              if(this.useInfo.USEMAIL == 1 && !emailVal.test(element[this.$t('eul_msg35')].trim())){
                this.$alert(i+1+this.$t('eul_msg59'));
                checkflag = false;
                return;
              } 

              if(this.useInfo.USEMAIL == 1 && (element[this.$t('eul_msg35')] != null && String(element[this.$t('eul_msg35')]).length >= 100) ){
                this.$alert(i+1+this.$t('eul_msg60'));
                checkflag = false;
                break;
              }


              if(this.useInfo.USEPW == 1 && (element[this.$t('eul_msg38')] == null || String(element[this.$t('eul_msg38')]).length < 1) ){
                this.$alert(i+1+this.$t('eul_msg61'));
                checkflag = false;
                break;
              }
              if(this.useInfo.USEPW == 1 && String(element[this.$t('eul_msg38')]).length != 4){
                this.$alert(i+1+this.$t('eul_msg62'));
                checkflag = false;
                break;
              }

              const numberVal1 = /[^0-9]/g;
              if(this.useInfo.USEPW == 1 && numberVal1.test(element[this.$t('eul_msg38')])){
                this.$alert(i+1+this.$t('eul_msg63'));
                checkflag = false;
                return;
              } 

              if(this.useInfo.USESEX == 1 && (element[this.$t('eul_msg39')] == null || String(element[this.$t('eul_msg39')]).length < 1) ){
                this.$alert(i+1+this.$t('eul_msg64'));
                checkflag = false;
                break;
              }

              if(this.useInfo.USESEX == 1 && String(element[this.$t('eul_msg39')]).length != 1){
                this.$alert(i+1+this.$t('eul_msg65'));
                checkflag = false;
                break;
              }

              if(this.useInfo.USESEX == 1 && numberVal1.test(element[this.$t('eul_msg39')])){
                this.$alert(i+1+this.$t('eul_msg66'));
                checkflag = false;
                return;
              } 

              if(this.useInfo.USEYEAR == 1 && (element[this.$t('eul_msg37')] == null || String(element[this.$t('eul_msg37')]).length < 1) ){
                this.$alert(i+1+this.$t('eul_msg67'));
                checkflag = false;
                break;
              }
              if(this.useInfo.USEYEAR == 1 && String(element[this.$t('eul_msg37')]).length != 4){
                this.$alert(i+1+this.$t('eul_msg68'));
                checkflag = false;
                break;
              }

              if(this.useInfo.USEYEAR == 1 && numberVal1.test(element[this.$t('eul_msg37')])){
                this.$alert(i+1+this.$t('eul_msg69'));
                checkflag = false;
                return;
              } 

              if(element[this.$t('eul_msg39')] == null || String(element[this.$t('eul_msg39')]).length < 1){
                this.$alert(i+1+this.$t('eul_msg70'));
                checkflag = false;
                break;
              }

              if(String(element[this.$t('eul_msg39')]).length != 1){
                this.$alert(i+1+this.$t('eul_msg71'));
                checkflag = false;
                break;
              }

              if(numberVal1.test(element[this.$t('eul_msg39')])){
                this.$alert(i+1+this.$t('eul_msg72'));
                checkflag = false;
                return;
              } 

              if(element[this.$t('eul_msg40')] != null || String(element[this.$t('eul_msg40')]).length > 0){
                if(numberVal1.test(element[this.$t('eul_msg40')])){
                  this.$alert(i+1+this.$t('eul_msg73'));
                  checkflag = false;
                  return;
                } 
              }

              if(numberVal1.test(element[this.$t('eul_msg102')])){
                this.$alert(i+1+this.$t('eul_msg103'));
                checkflag = false;
                return;
              } 

            }

            if(!checkflag){
              this.excel_prog = false;
              this.excel_dialog = false;
              return;
            }


            //서버로 전송해서 처리
            this.$http.post(this.$host+'/api/VisitorUpload',{
                JSONVALUE: escape(JSON.stringify(uploaditem))
              , INFOVALUE: escape(JSON.stringify(requiredColumns))
              , NATION: this.excelItem.NATION
              , OPTION_IDX: this.excelItem.OPTION_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , LOCAL_COLUMN: this.$t("eul_excel44")
              , OPTION_COLUMN: this.$t("eul_excel32")
              , COMMENT_COLUMN: this.$t("eul_msg32")
              , COMMENT_COLUMN2: this.$t("eul_msg33")
              , PART_TYPE: this.useInfo.PART_TYPE
              , TEL_COLUMN: this.$t("eul_msg34")
              , EMAIL_COLUMN: this.$t("eul_msg35")
              , GENDER_COLUMN: this.$t("eul_msg36")
              , YEAR_COLUMN: this.$t("eul_msg37")
              , PW_COLUMN: this.$t("eul_msg38")
              , STATE_COLUMN: this.$t("eul_msg39")
              , REGTYPE_COLUMN: this.$t("eul_msg102")
              , SORT_COLUMN: this.$t("eul_msg40")
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.excel_prog   = false;
              this.excel_dialog = false;
              if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                  this.$alert(this.$t('common_insert_msg')).then(()=>{
                    this.page = 0;
                    this.loadpage(1);
                  });

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                this.$alert(this.$t("common_insert_fail"));
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              this.excel_prog   = false;
              this.excel_dialog = false;
              this.$alert(this.$t("common_insert_fail"));
            });

          }

          reader.readAsBinaryString(this.uploadFile);  //비동기로 파일을 읽어서

        });


      },

      //서버에 전송하기 위한 컬럼명 변경
      convertUploadItem(item, flag){

        // 깊은 복사를 통해 새로운 객체 생성 (원본 객체에 영향 없음)
        const newItem = JSON.parse(JSON.stringify(item));
        
        // flag가 true이고 REQTYPE이 1인 경우에만 처리 앞에 *붙이기 처리.
        if (flag && item.REQTYPE === 1) {

          // NAME 앞에 * 추가
          if(newItem.NAME) {
            newItem.NAME = '*' + newItem.NAME;
          }

          // ENAME이 존재하고 값이 있을 때만 * 추가
          if(newItem.ENAME && newItem.ENAME.trim() !== '') {
            newItem.ENAME = '*' + newItem.ENAME;
          }          

        }

        if(item.LANTYPE == 2){
          newItem.NAME += ",영문만입력";
          newItem.ENAME += ", English only";
        }
        
        return newItem;

      },


      //엑셀 데이터를 등록번호 기준으로 덮어쓰기
      uploadUpdateExcel() {

        if (this.uploadFile == null) {
          this.$alert(this.$t('eul_msg46'));
          return;
        }

        this.$confirm(this.$t('eul_msg104')).then(() => {
          this.excel_prog = true;
          const reader = new FileReader();

          reader.onload = () => {
            try {
              var fileData = reader.result;
              let workbook = XLSX.read(fileData, { type: 'binary' });
              var firstSheetName = workbook.SheetNames[0];
              var firstSheet = workbook.Sheets[firstSheetName];
              
              // 엑셀 데이터를 JSON으로 변환 (빈 셀은 빈 문자열로 처리)
              let wrokjson = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });

              if (wrokjson.length < 1) {
                this.$alert(this.$t('eul_msg48'));
                this.excel_prog = false;
                return;
              }

              // 1. [매핑 및 기준 컬럼 생성] 서버가 DB 컬럼(INFO1~20)을 정확히 찾게 함
              var read_column = [];
              var base_column = {};

              // 나머지 추가 정보 처리 (1~20)
              for (var k = 1; k < this.infoItem.length; k++) {
                if (this.infoItem[k].USETYPE == 1) {
                  read_column.push({
                    db_idx: k + 1,
                    excel_name: this.getColumnName(this.infoItem[k])
                  });
                }
              }

              // 가변 기본 컬럼 정보 (서버 매핑용)
              if (this.useInfo.USESEX == 1) base_column.SEX = this.$t('eul_excel12');
              if (this.useInfo.USEYEAR == 1) base_column.YEAR = this.$t('eul_excel13');
              //if (this.useInfo.USENATION == 1) base_column.NATION = this.$t('eul_excel11');

              // 2. [헤더 검증] 엑셀에 필요한 모든 컬럼이 존재하는지 이름 기반으로 전수 조사
              var excelHeader = Object.keys(wrokjson[0]);
              var missingColumns = [];
              
              // 반드시 있어야 하는 컬럼 리스트 구성
              var checkList = [
                this.$t('eul_excel0'),  // idx
                this.$t('eul_excel55'), // 등록순서 
                this.$t('eul_excel4'),  // 등록 카테고리
                this.$t('eul_excel32'), // 카테고리 코드 
                this.$t('eul_excel29'), // 등록타입 코드
                this.$t('eul_excel5'),  // 상태
                this.$t('eul_col20'),   // 구분
                this.$t('eul_excel7'),  // 이름
                this.$t('eul_excel8'),  // 전화번호
                this.$t('eul_excel10')  // 이메일
              ];
              
              // 설정된 가변 항목 추가
              Object.values(base_column).forEach(name => checkList.push(name));
              // 설정된 INFO 항목 추가
              read_column.forEach(item => checkList.push(item.excel_name));

              // 엑셀 헤더에 해당 이름이 다 있는지 검사
              [...new Set(checkList)].forEach(col => {
                console.log(`check : ${JSON.stringify(col)}`);
                if (!excelHeader.includes(col)) {
                  missingColumns.push(col);
                  console.log(`miss : ${JSON.stringify(col)}`);
                }
              });

              if (missingColumns.length > 0) {
                this.$alert(this.$t('eul_msg49'));
                this.excel_prog = false;
                return;
              }

              // 3. [데이터 유효성 검사] - 사용자님 로직 100% 반영
              var checkflag = true;
              const numberVal1 = /[^0-9]/g;
              const mobileVal1 = /[^0-9-]/g;
              const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
              const idxValues = this.optionItem.map(item => String(item.IDX));

              for (var i = 0; i < wrokjson.length; i++) {
                var element = wrokjson[i];
                var rowNum = i + 1;

                // 등록카테고리(옵션) 검증
                if (!idxValues.includes(String(element[this.$t('eul_excel32')]).trim())) {
                  this.$alert(rowNum + this.$t('eul_msg111'));
                  checkflag = false; break;
                }

                // 내외국인 구분 검증
                if (element[this.$t('eul_col20')] == null || String(element[this.$t('eul_col20')]).trim().length < 1) {
                  this.$alert(rowNum + this.$t('eul_msg112'));
                  checkflag = false; break;
                }

                // 등록번호 검증
                if (element[this.$t('eul_excel0')] == null || String(element[this.$t('eul_excel0')]).trim().length < 1) {
                  this.$alert(rowNum + this.$t('eul_msg108'));
                  checkflag = false; break;
                }

                // 이름 검증
                if (element[this.$t('eul_excel7')] == null || String(element[this.$t('eul_excel7')]).trim().length < 1) {
                  this.$alert(rowNum + this.$t('eul_msg109'));
                  checkflag = false; break;
                }

                // 전화번호 검증
                if (this.useInfo.USETEL == 1) {
                  var telVal = String(element[this.$t('eul_excel8')]).trim();
                  if (telVal.length < 1) {
                    this.$alert(rowNum + this.$t('eul_msg54'));
                    checkflag = false; break;
                  }
                  if (mobileVal1.test(telVal)) {
                    this.$alert(rowNum + this.$t('eul_msg55'));
                    checkflag = false; break;
                  }
                  if (telVal.length >= 40) {
                    this.$alert(rowNum + this.$t('eul_msg56'));
                    checkflag = false; break;
                  }
                }

                // 이메일 검증
                if (this.useInfo.USEMAIL == 1) {
                  var emailValStr = String(element[this.$t('eul_excel10')]).trim();
                  var emailPattern = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[-_.0-9a-zA-Z][-_.0-9a-zA-Z]*.[a-zA-Z]{2,3}$/i;
                  if (emailValStr.length < 1) {
                    this.$alert(rowNum + this.$t('eul_msg58'));
                    checkflag = false; break;
                  }
                  if (!emailPattern.test(emailValStr)) {
                    this.$alert(rowNum + this.$t('eul_msg59'));
                    checkflag = false; break;
                  }
                  if (emailValStr.length >= 100) {
                    this.$alert(rowNum + this.$t('eul_msg60'));
                    checkflag = false; break;
                  }
                }

                // 출생연도 검증
                if (this.useInfo.USEYEAR == 1) {
                  var yearStr = String(element[this.$t('eul_excel13')]).trim();
                  if (yearStr.length < 1) {
                    this.$alert(rowNum + this.$t('eul_msg67'));
                    checkflag = false; break;
                  }
                  if (yearStr.length != 4) {
                    this.$alert(rowNum + this.$t('eul_msg68'));
                    checkflag = false; break;
                  }
                  if (numberVal1.test(yearStr)) {
                    this.$alert(rowNum + this.$t('eul_msg69'));
                    checkflag = false; break;
                  }
                }

                // 정보1 ~ 정보20 (INFO 필드) 상세 검증
                for (var j = 0; j < read_column.length; j++) {
                  var colName = read_column[j].excel_name;
                  var cellValue = String(element[colName] || "").trim();
                  // infoItem 배열에서 실제 설정값 참조
                  var infoConfig = this.infoItem[read_column[j].db_idx - 1];

                  if (infoConfig.USETYPE == 0 || infoConfig.SHOWTYPE == 0) continue;

                  // 필수 입력 체크
                  if (infoConfig.REQTYPE == 1 && cellValue.length < 1) {
                    this.$alert(rowNum + this.$t('eul_msg50') + " [" + colName + "] " + this.$t('eul_msg51'));
                    checkflag = false; break;
                  }
                  // 영문 전용 체크
                  if (infoConfig.LANTYPE == 2 && korean.test(cellValue)) {
                    this.$alert(rowNum + this.$t('eul_msg50') + " [" + colName + "] " + this.$t('eul_msg52'));
                    checkflag = false; break;
                  }
                  // 글자수 제한 체크
                  if (cellValue.length >= 200) {
                    this.$alert(rowNum + this.$t('eul_msg50') + " [" + colName + "] " + this.$t('eul_msg53'));
                    checkflag = false; break;
                  }
                }
                if (!checkflag) break;

                // 설명1, 설명2 글자수 체크
                if (element[this.$t('eul_excel26')] != null && String(element[this.$t('eul_excel26')]).length >= 500) {
                  this.$alert(rowNum + this.$t('eul_msg57'));
                  checkflag = false; break;
                }
                if (element[this.$t('eul_excel27')] != null && String(element[this.$t('eul_excel27')]).length >= 500) {
                  this.$alert(rowNum + this.$t('eul_msg107'));
                  checkflag = false; break;
                }

                // 순서 필드 숫자 체크
                if (element[this.$t('eul_excel30')] != null && String(element[this.$t('eul_excel30')]).length > 0) {
                  if (numberVal1.test(String(element[this.$t('eul_excel30')]).trim())) {
                    this.$alert(rowNum + this.$t('eul_msg73'));
                    checkflag = false; break;
                  }
                }

                // 등록타입(REGTYPE) 검증
                var regTypeStr = String(element[this.$t('eul_excel29')]).trim();
                if (regTypeStr.length < 1) {
                  this.$alert(rowNum + this.$t('eul_msg106'));
                  checkflag = false; break;
                }
                if (numberVal1.test(regTypeStr)) {
                  this.$alert(rowNum + this.$t('eul_msg103'));
                  checkflag = false; break;
                }
                if (parseInt(regTypeStr) < 0 || parseInt(regTypeStr) > 2) {
                  this.$alert(rowNum + this.$t('eul_msg105'));
                  checkflag = false; break;
                }
              }

              if (!checkflag) {
                this.uploadFile = null;
                this.excel_prog = false;
                return;
              }

              // 4. [서버 전송]
              this.$http.post(this.$host + '/api/VisitorUpdateUpload2', {
                JSONVALUE: escape(JSON.stringify(wrokjson)),
                INFOVALUE: escape(JSON.stringify(read_column)),
                BASEVALUE: escape(JSON.stringify(base_column)), // 가변 기본컬럼 매핑 전송
                PART_TYPE: this.useInfo.PART_TYPE,
                ADMIN_IDX: this.$session.get("ADMIN_IDX"),
                EVENT_IDX: this.SEARCH_EVENT_IDX,
                IDX_COLUMN: this.$t("eul_excel0"),
                REGSORT_COLUMN: this.$t("eul_excel55"),
                OPTION_COLUMN: this.$t("eul_excel32"),
                LOCAL_COLUMN: this.$t("eul_col20"),
                NAME_COLUMN: this.$t("eul_excel7"),
                TEL_COLUMN: this.$t("eul_excel8"),
                EMAIL_COLUMN: this.$t("eul_excel10"),
                YEAR_COLUMN: this.$t("eul_excel13"),
                COMMENT_COLUMN: this.$t("eul_excel26"),
                COMMENT_COLUMN2: this.$t("eul_excel27"),
                SORT_COLUMN: this.$t("eul_excel30"),
                REGTYPE_COLUMN: this.$t("eul_excel29"),
                LAN_CODE: this.$i18n.locale
              }, {
                headers: { 
                  accesstoken: this.$session.get("ACCESSTOKEN"), 
                  reflashtoken: this.$session.get("REFLASHTOKEN") 
                }
              }).then((result) => {
                this.excel_prog = false;
                this.excelupdate_dialog = false;
                if (result.data.resultCode == 0) {
                  if (result.data.accesstoken) this.$session.set("ACCESSTOKEN", result.data.accesstoken);
                  if (result.data.reflashtoken) this.$session.set("REFLASHTOKEN", result.data.reflashtoken);
                  this.$alert(this.$t('common_insert_msg')).then(() => {
                    this.page = 0;
                    this.loadpage(1);
                  });
                } else if (result.data.resultCode == 2) {
                  this.$alert(this.$t("common_tokener"));
                  this.$session.clear();
                  this.$router.push('Login');
                } else {
                  this.$alert(result.data.resultMsg);
                }
              }).catch((error) => {
                this.excel_prog = false;
                this.$alert(this.$t("common_insert_fail" + error));
              });

            } catch (err) {
              console.error(err);
              this.excel_prog = false;
              this.$alert("Processing error.");
            }
          };
          reader.readAsBinaryString(this.uploadFile);
        });
      },

      //참가자 명단 다운로드
      startDownload(){

        this.$confirm(this.$t('eul_msg74')).then(() => {

          if(this.grade < 99){
            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
          }

          if(this.grade < 99){
            if(this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t('common_select_tevent'));
              return;
            }
          }

          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorListExcel',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
              , SEARCH_OPTION: this.SEARCH_OPTION
              , SEARCH_STATE: this.SEARCH_STATE
              , SEARCH_NATIONSTATE: this.SEARCH_NATIONSTATE
              , SEARCH_REGTYPESTATE: this.SEARCH_REGTYPESTATE
              , SHOWREVIEW: this.showreview ? 1 : 0
              , search_start_date: this.checkdate ? this.search_start_date == undefined ? '' : this.search_start_date : ''
              , search_end_date: this.checkdate ? this.search_end_date == undefined ? '' : this.search_end_date : ''
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;

                //불필요한 컬럼 데이터 제거
                const filteredList = list.map(item => {
                  
                  const row = {};
                  
                  // 고정 헤더 매핑 (서버 쿼리의 Alias와 일치시켜야 함)
                  row['IDX']        = item['IDX'];
                  row['등록순서']    = item['등록순서'] || item['REGSORT'];
                  row['옵션명']      = item['옵션명'] || item['Option Name'];
                  row['카테고리코드'] = item['옵션코드'] || item['Option Code'];
                  row['등록타입']    = item['등록타입'] || item['RegType'];
                  row['상태']       = item['상태'] || item['State'];
                  row['구분']       = item['구분'] || item['Class'];
                  row['이름']       = item['이름'] || item['Name'];

                  // 조건부 필드 (this.useInfo에 따른 처리)
                  row['전화번호'] = item['전화번호'] || item['Tel'];
                  row['이메일'] = item['이메일'] || item['Email'];
                  if(this.useInfo.USENATION == 1) row['국적'] = item['국적'] || item['Nation'];
                  if(this.useInfo.USESEX == 1) row['성별'] = item['성별'] || item['Gender'];
                  if(this.useInfo.USEYEAR == 1) row['출생연도'] = item['출생연도'] || item['Year of birth'];

                  for(var k=1;k<this.infoItem.length;k++){
                    if(this.infoItem[k].USETYPE == 1) row[`인포${k+1}`] = item[`INFO${k+1}`];
                  }

                  // 동적 선택 등록 양식 (VALUE1, VALUE2 등)
                  // result.data.resultNames에 포함된 동적 컬럼만 추가
                  result.data.resultNames.forEach(nameObj => {
                    row[nameObj.IDX] = item[nameObj.IDX]; 
                  });

                  row['접수일시'] = item['접수일시'] || item['Reception time'];
                  row['결제일시'] = item['결제일시'] || item['Payment time'];
                  row['등록비'] = item['등록비'] || item['Fee'];
                  row['결제금액'] = item['결제금액'] || item['Payment'];
                  row['정산금액'] = item['정산금액'] || item['Calculate'];
                  row['출력일시'] = item['출력일시'] || item['Print time'];
                  row['출력횟수'] = item['출력횟수'] || item['Print Count'];
                  row['설명1'] = item['COMMENT'];
                  row['설명2'] = item['COMMENT2'];
                  row['순서'] = item['SORT'];
                  row['등록타입코드'] = item['REG_TYPE'];
                  row['만족도조사'] = item['ISINSPECT'];
                  row['마케팅동의'] = item['MKTAGREE'];

                  // KEY 값들 - 출입관리 사용시에만 
                  if(this.useInfo.PART_TYPE == 1){
                    for(let i=1; i<=10; i++) {
                      row[`KEY${i}`] = item[`KEY${i}`];
                    }
                  }

                  return row;
                });                

                var item_sheet = XLSX.utils.json_to_sheet(filteredList);


                // 숫자 서식 유지할 컬럼 키 목록
                const numericKeys = ['출력횟수'];
                const firstRow = filteredList[0] ? Object.keys(filteredList[0]) : [];
                const numericColIndexes = new Set(
                  numericKeys.map(k => firstRow.indexOf(k)).filter(i => i !== -1)
                );

                //모든 셀을 스트링 서식으로 강제 지정
                Object.keys(item_sheet).forEach(cell => {
                  if (cell.startsWith('!')) return; // 시트 메타데이터 무시
                  
                  //컬럼 인덱스 추출
                  const colIndex = XLSX.utils.decode_cell(cell).c;
                  const cellData = item_sheet[cell];

                  // 1. 셀 데이터 자체가 없거나 값이 null/undefined인 경우 처리
                  if (!cellData || cellData.v === null || cellData.v === undefined) {
                      item_sheet[cell].v = ""; // 빈 문자열로 초기화
                      item_sheet[cell].t = "s";
                  }else if(numericColIndexes.has(colIndex)){
                    // ✅ 숫자 컬럼은 number 타입 유지
                    item_sheet[cell].v = Number(cellData.v) || 0;
                    item_sheet[cell].t = 'n';
                    item_sheet[cell].z = '#,##0';  // 천단위 콤마 서식 (원하면 제거)
                  } else {
                    // 2. 값이 있는 경우에만 스트링 타입 및 서식 지정
                    // 기존 값을 문자로 변환하여 저장 (혹시 모를 숫자형 데이터 방지)
                    item_sheet[cell].v = String(cellData.v);
                    item_sheet[cell].t = 's';
                  }
                    // 3. 텍스트 서식 지정
                    item_sheet[cell].z = '@';
                    // 4. 스타일 지정 (폰트 사이즈 10, 가운데 정렬)
                    item_sheet[cell].s = {
                      font: { sz: 10 },
                      alignment: { horizontal: 'center', vertical: 'center' }
                    };
                });                

                const headers = [];
                headers.push({name: this.$t('eul_excel0'), editable: 0});   // IDX
                headers.push({name: this.$t('eul_excel55'), editable: 1});  // 등록순서
                headers.push({name: this.$t('eul_excel4'), editable: 0});   //등록카테고리(이름)
                headers.push({name: this.$t('eul_excel32'), editable: 1});  //카테고리 코드
                headers.push({name: this.$t('eul_excel28'), editable: 0});  //등록타입(이름)
                headers.push({name: this.$t('eul_excel5'), editable: 0});   //상태
                headers.push({name: this.$t('eul_col20'), editable: 0});    //내외국인 구분
                headers.push({name: this.$t('eul_excel7'), editable: 1});   //이름

                headers.push({name: this.$t('eul_excel8'), editable: 1});  //전화
                headers.push({name: this.$t('eul_excel10'), editable: 1}); //이메일
                if(this.useInfo.USENATION == 1) headers.push({name: this.$t('eul_excel11'), editable: 0}); //국적
                if(this.useInfo.USESEX == 1) headers.push({name: this.$t('eul_excel12'), editable: 1}); //성별
                if(this.useInfo.USEYEAR == 1) headers.push({name: this.$t('eul_excel13'), editable: 1}); //출생연도

                for(var k=1;k<this.infoItem.length;k++){
                  if(this.infoItem[k].USETYPE == 1) headers.push({name: this.getColumnName(this.infoItem[k]), editable: 1});
                }

                //동적 선택 등록 양식 헤더 추가 (이 부분이 누락되어 순서가 밀린 것임)
                //filteredList에서 row[nameObj.IDX]를 추가한 것과 동일한 위치에 제목을 push 합니다.
                result.data.resultNames.forEach(nameObj => {
                  headers.push({name: nameObj.TITLE, editable: 0});
                });

                headers.push({name: this.$t('eul_excel23'), editable: 0}); //접수일시
                headers.push({name: this.$t('eul_excel42'), editable: 0}); //결제일시

                headers.push({name: this.$t('eul_excel40'), editable: 0}); //등록비
                headers.push({name: this.$t('eul_excel9'), editable: 0});  //결제금액
                headers.push({name: this.$t('eul_excel41'), editable: 0}); //정산금액

                headers.push({name: this.$t('eul_excel25'), editable: 0}); //출력일시
                headers.push({name: this.$t('eul_excel24'), editable: 0}); //출력횟수

                headers.push({name: this.$t('eul_excel26'), editable: 1});
                headers.push({name: this.$t('eul_excel27'), editable: 1});
                headers.push({name: this.$t('eul_excel30'), editable: 1});
                headers.push({name: this.$t('eul_excel29'), editable: 1});

                headers.push({name: this.$t('eul_excel43'), editable: 0});   //만족도조사
                headers.push({name: this.$t('eul_excel31'), editable: 0});   //마케팅동의

                //KEY
                if(this.useInfo.PART_TYPE == 1){
                  headers.push({name: this.$t('eventplace_excel10'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel11'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel12'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel13'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel14'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel15'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel16'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel17'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel18'), editable: 1});
                  headers.push({name: this.$t('eventplace_excel19'), editable: 1});
                }

                // 헤더명만 추출하여 시트에 추가
                const headerNames = headers.map(h => h.name);
                XLSX.utils.sheet_add_aoa(item_sheet, [headerNames], { origin: "A1" });

                // 헤더 스타일 적용 (editable에 따라 색상 분기)
                // 수정불가(0): 남색(0f243e), 수정가능(1): 녹색(2e7d32)
                for (let i = 0; i < headers.length; i++) {
                  const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
                  if (item_sheet[cellRef]) {
                    item_sheet[cellRef].s = {
                      font: { sz: 10, bold: true, color: { rgb: "FFFFFF" } },
                      fill: { fgColor: { rgb: headers[i].editable == 1 ? "366092" : "0f243e" } },
                      alignment: { horizontal: 'center', vertical: 'center' }
                    };
                  }
                }

                // 데이터 셀 스타일 적용 (폰트 사이즈 10, 가운데 정렬, 첫번째 열은 볼드)
                const range = XLSX.utils.decode_range(item_sheet['!ref']);
                for (let R = 1; R <= range.e.r; R++) {
                  for (let C = 0; C <= range.e.c; C++) {
                    const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                    if (item_sheet[cellRef]) {
                      item_sheet[cellRef].s = {
                        font: { sz: 10, bold: C === 0 },
                        alignment: { horizontal: 'center', vertical: 'center' }
                      };
                    }
                  }
                }

                //5. 자동 너비 계산
                const colWidths = headers.map((h, i) => {
                  let maxLen = this.getByteLength(h.name);
                  // 데이터 행 50개 정도만 검사해서 최대 길이 추출 (성능 고려)
                  for (let r = 0; r < Math.min(filteredList.length, 50); r++) {
                    const cellValue = Object.values(filteredList[r])[i];
                    const cellLen = this.getByteLength(cellValue);
                    if (cellLen > maxLen) maxLen = cellLen;
                  }
                  return { wch: Math.min(maxLen + 2, 50) }; // 최대 50으로 제한
                });
                item_sheet['!cols'] = colWidths;

                // 첫번째 행(헤더) 높이 설정
                item_sheet['!rows'] = [{ hpt: 25 }];

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('eul_msg75'));
                XLSX.writeFile(wb, this.SEARCH_EVENT_NAME+"_"+this.$t('eul_msg76')+moment().format('YYYYMMDDHHmmss')+'.xlsx');


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });

      },

      customsort(sortname){

        if(this.columnIdx != null){
          return;
        }

        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
        
        this.itemList.splice(0, this.itemList.length);   
        this.selectList.splice(0, this.selectList.length);   

        
        //if(this.grade < 99){
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
        //}

        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

          this.loading = true;
          this.page = p;
          this.$http.post(this.$host+'/api/VisitorList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
              , SEARCH_OPTION: this.SEARCH_OPTION
              , SEARCH_STATE: this.SEARCH_STATE
              , SEARCH_NATIONSTATE: this.SEARCH_NATIONSTATE
              , SEARCH_REGTYPESTATE: this.SEARCH_REGTYPESTATE
              , SHOWREVIEW: this.showreview ? 1 : 0
              , search_start_date: this.checkdate ? this.search_start_date == undefined ? '' : this.search_start_date : ''
              , search_end_date: this.checkdate ? this.search_end_date == undefined ? '' : this.search_end_date : ''
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;

                if(this.page == 1 && list.length > 0){

                  //헤더 처리
                  this.headers.splice(0, this.headers.length);
                  if(this.SEARCH_COM_IDX != null && this.SEARCH_COM_IDX != undefined && this.SEARCH_EVENT_IDX != null && this.SEARCH_EVENT_IDX != undefined){

                    //해당 행사 전용 정보 표시
                    this.headers = [
                      {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
                      {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
                      {text: '등록번호', value: 'IDX', width:100, sortable: false, align:'center' },
                      {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
                      {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
                      {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
                      {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
                      {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
                      {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
                      {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
                      {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },
                    ];

                    //기본등록양식
                    for(var i=1;i<this.infoItem.length;i++){
                      if(this.infoItem[i].SHOWTYPE == 1){
                        //사용일 경우
                        this.headers.push({text: this.infoItem[i].NAME, value: 'INFO'+(i+1), width:150, sortable: false, align:'center' });
                      }
                    }

                    //선택등록양식
                    this.header_names.splice(0, this.header_names.length);   
                    result.data.resultNames.forEach(element => {

                      if(element.TITLE.length > 12){
                        //12자가 넘어가면 제목에 따라서 넓이를 키워라.
                        var dynamic_width = (element.TITLE.length * 16) + 50; 
                        this.headers.push({text: element.TITLE, value: element.IDX, width:dynamic_width, sortable: false, align:'center', class:`${element.IDX}` }); 
                      }else{
                        this.headers.push({text: element.TITLE, value: element.IDX, width:200, sortable: false, align:'center', class:`${element.IDX}` }); 
                      }
                      this.header_names.push(element);
                      
                    });

                    this.headers.push({text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' });
                    this.headers.push({text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' });

                    this.headers.push({text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' });
                    this.headers.push({text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' });
                    this.headers.push({text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' });
                    
                    this.headers.push({text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' });
                    this.headers.push({text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' });
                    
                    this.headers.push({text: '만족도조사', value: 'ISINSPECT', width:200,sortable: false, align:'center' });
                    this.headers.push({text: '마케팅동의', value: 'MKTAGREE', width:200,sortable: false, align:'center' });
                    
                    this.headers.push({text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'});
                    this.headers.push({text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'});

                  }else{

                    //기본정보 표시
                    this.headers = [
                      {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
                      {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
                      {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
                      {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
                      {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
                      {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
                      {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
                      {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
                      {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
                      {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },
                      
                      {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
                      {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

                      {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
                      {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
                      {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },

                      {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
                      {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
                      
                      {text: '만족도조사', value: 'ISINSPECT', width:120,sortable: false, align:'center' },
                      {text: '마케팅동의', value: 'MKTAGREE', width:120,sortable: false, align:'center' },
                      {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
                      {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
                    ];

                  }
                
                }else if(this.page == 1 && list.length == 0){

                    //기본정보 표시
                    this.headers = [
                      {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
                      {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
                      {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
                      {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
                      {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
                      {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
                      {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
                      {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
                      {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
                      {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },

                      {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
                      {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

                      {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
                      {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
                      {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },
                      
                      {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
                      {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
                      
                      {text: '만족도조사', value: 'ISINSPECT', width:120,sortable: false, align:'center' },
                      {text: '마케팅동의', value: 'MKTAGREE', width:120,sortable: false, align:'center' },
                      
                      {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
                      {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
                    ];
                
                    
                }

                list.forEach(element => {
                    element.YEAR =  element.YEAR.toString();  //변경 안해주면 오류남..
                    this.itemList.push(element); 
                });

                this.loading = false;
                
                


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      //QR코드로 참가자 조회
      loadQrcode(){

        if(this.grade < 99){
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
        }

        if(this.qr_code == null || this.qr_code == undefined || this.qr_code.length == 0){
          this.$alert(this.$t('eul_msg77'));
          return;
        }

          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorDetailQR',{
                search_keyword: this.qr_code
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , COM_IDX: this.SEARCH_COM_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                const tempList = [];
                list.forEach(element => {
                    element.YEAR =  element.YEAR.toString();  //변경 안해주면 오류남..
                    tempList.push(element); 
                });
                if(tempList.length > 0){
                  this.edit_itemQR(tempList[0]);
                }
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },      

      initpage(){
        
        this.designList = new Map();
        
        this.getInfoItemList();
        this.getEventOption();

        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          //선택인원 초기화
          this.selectList.splice(0, this.selectList.length);
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300)
      },

      //추가 저장
      save () {

        const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

        if(this.editedItem.OPTION_IDX  == undefined || this.editedItem.OPTION_IDX.length < 1){
          this.$alert(this.$t('eul_msg78'));
          return;
        } 

        for(var i=1;i<=20;i++){

          if(this.infoItem[i-1].USETYPE == 0){
            //사용 안함이면 패스
            continue;
          }
          if(this.infoItem[i-1].REQTYPE == 1){
            //필수 입력이면 체크
            if(this.editedItem['INFO'+i] == undefined || this.editedItem['INFO'+i].length < 1){
              this.$alert(this.infoItem[i-1].NAME + this.$t('eul_msg79'));
              return;
            }
          }
          if(this.infoItem[i-1].LANTYPE == 2){
            //영문만 사용 가능한 경우
            if(korean.test(this.editedItem['INFO'+i])){
              this.$alert(this.infoItem[i-1].NAME+this.$t('eul_msg80'));
              return;
            }
          }
        }

        const numberVal1 = /[^0-9]/g;
        if(this.editedItem.SORT != null && String(this.editedItem.SORT).length > 0){
          if(numberVal1.test(this.editedItem.SORT)){
            this.$alert(this.$t('eul_msg81') + this.editedItem.SORT);
            return;
          } 
        }

        if(this.useInfo.USETEL == 1){
          if(this.editedItem.TEL  == undefined || this.editedItem.TEL.length < 1){
            this.$alert(this.$t('eul_msg82'));
            return;
          } 
          const mobileVal1 = /[^0-9-]/g;
          if(mobileVal1.test(this.editedItem.TEL)){
            this.$alert(this.$t('eul_msg83'));
            return;
          } 
        }else{
          this.editedItem.TEL = "";
        }

        if(this.useInfo.USEMAIL == 1){
          if(this.editedItem.EMAIL == null || this.editedItem.EMAIL.length < 1){
            this.$alert(this.$t('eul_msg84'));
            return;
          }
          //var emailVal = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
          //var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[-_.0-9a-zA-Z][-_.0-9a-zA-Z]*.[a-zA-Z]{2,3}$/i;
          var emailVal = /^[0-9a-zA-Z][-_.0-9a-zA-Z]*@[0-9a-zA-Z][-_.0-9a-zA-Z]*(\.[a-zA-Z]{2,})+$/i;
          if(!emailVal.test(this.editedItem.EMAIL)){
            this.$alert(this.$t('eul_msg85'));
            return;
          } 
        }else{
          this.editedItem.EMAIL = "";
        }
        
        const passVal1 = /[^0-9]/g;
        if(this.useInfo.USEPW == 1){
          if(this.editedItem.PRINT_NUMBER == null){
            this.$alert(this.$t('eul_msg86'));
            return;
          }
          if(this.editedItem.PRINT_NUMBER.length != 4){
            this.$alert(this.$t('eul_msg86'));
            return;
          }
          if(passVal1.test(this.editedItem.PRINT_NUMBER)){
            this.$alert(this.$t('eul_msg87'));
            return;
          } 
        }else{
          this.editedItem.PRINT_NUMBER = "0000";
        }

        if(this.useInfo.USEYEAR == 1){
          if(this.editedItem.YEAR  == undefined || this.editedItem.YEAR.length < 1){
            this.$alert(this.$t('eul_msg88'));
            return;
          } 
          if(this.editedItem.YEAR.length != 4){
            this.$alert(this.$t('eul_msg89'));
            return;
          } 
          if(passVal1.test(this.editedItem.YEAR)){
            this.$alert(this.$t('eul_msg90'));
            return;
          } 
          if( parseInt(this.editedItem.YEAR) < 1900 || parseInt(this.editedItem.YEAR) > parseInt(new Date().getFullYear())){
            this.$alert(this.$t('eul_msg91'));
            return;
          } 
        }else{
          this.editedItem.YEAR = "1985";
        }

        let tel = this.editedItem.TEL == null || this.editedItem.TEL == undefined ? "" : this.editedItem.TEL.replace(/[^0-9]/g, "");
        if (tel.startsWith("10") && tel.length === 10) {
          tel = "0" + tel;
        }
        
        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorUpdate',{
                COM_IDX: this.editedItem.COM_IDX
              , INFO1: escape(this.editedItem.INFO1.replace(/\t/g, "").trim())
              , INFO2: escape(this.editedItem.INFO2)
              , INFO3: escape(this.editedItem.INFO3)
              , INFO4: escape(this.editedItem.INFO4)
              , INFO5: escape(this.editedItem.INFO5)
              , INFO6: escape(this.editedItem.INFO6)
              , INFO7: escape(this.editedItem.INFO7)
              , INFO8: escape(this.editedItem.INFO8)
              , INFO9: escape(this.editedItem.INFO9)
              , INFO10: escape(this.editedItem.INFO10)
              , INFO11: escape(this.editedItem.INFO11)
              , INFO12: escape(this.editedItem.INFO12)
              , INFO13: escape(this.editedItem.INFO13)
              , INFO14: escape(this.editedItem.INFO14)
              , INFO15: escape(this.editedItem.INFO15)
              , INFO16: escape(this.editedItem.INFO16)
              , INFO17: escape(this.editedItem.INFO17)
              , INFO18: escape(this.editedItem.INFO18)
              , INFO19: escape(this.editedItem.INFO19)
              , INFO20: escape(this.editedItem.INFO20)
              , KEY1: escape(this.editedItem.KEY1)
              , KEY2: escape(this.editedItem.KEY2)
              , KEY3: escape(this.editedItem.KEY3)
              , KEY4: escape(this.editedItem.KEY4)
              , KEY5: escape(this.editedItem.KEY5)
              , KEY6: escape(this.editedItem.KEY6)
              , KEY7: escape(this.editedItem.KEY7)
              , KEY8: escape(this.editedItem.KEY8)
              , KEY9: escape(this.editedItem.KEY9)
              , KEY10: escape(this.editedItem.KEY10)
              , COMMENT: this.editedItem.COMMENT == null || this.editedItem.COMMENT == undefined ? "" : escape(this.editedItem.COMMENT)
              , COMMENT2: this.editedItem.COMMENT2 == null || this.editedItem.COMMENT2 == undefined ? "" : escape(this.editedItem.COMMENT2)
              , TEL: tel
              , EMAIL: this.editedItem.EMAIL == null || this.editedItem.EMAIL == undefined ? "" : escape(this.editedItem.EMAIL)
              , SEX: this.editedItem.SEX == null || this.editedItem.SEX == undefined ? 1 : this.editedItem.SEX
              , ISFOREIGNER: this.editedItem.ISFOREIGNER == null || this.editedItem.ISFOREIGNER == undefined ? 0 : this.editedItem.ISFOREIGNER
              , YEAR: this.editedItem.YEAR == null || this.editedItem.YEAR == undefined ? "1985" : this.editedItem.YEAR
              , NATION: this.editedItem.NATION == null || this.editedItem.NATION == undefined ? "KR" : this.editedItem.NATION
              , PRINT_NUMBER: this.editedItem.PRINT_NUMBER == null || this.editedItem.PRINT_NUMBER == undefined ? "0000" : this.editedItem.PRINT_NUMBER
              , REG_TYPE: this.editedItem.REG_TYPE
              , STATE: this.editedItem.STATE
              , REGSORT: this.editedItem.REGSORT
              , SORT: this.editedItem.SORT
              , OPTION_IDX: this.editedItem.OPTION_IDX
              , IDX: this.editedItem.IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorInsert',{
                COM_IDX: this.editedItem.COM_IDX
              , INFO1: escape(this.editedItem.INFO1.replace(/\t/g, "").trim())
              , INFO2: escape(this.editedItem.INFO2)
              , INFO3: escape(this.editedItem.INFO3)
              , INFO4: escape(this.editedItem.INFO4)
              , INFO5: escape(this.editedItem.INFO5)
              , INFO6: escape(this.editedItem.INFO6)
              , INFO7: escape(this.editedItem.INFO7)
              , INFO8: escape(this.editedItem.INFO8)
              , INFO9: escape(this.editedItem.INFO9)
              , INFO10: escape(this.editedItem.INFO10)
              , INFO11: escape(this.editedItem.INFO11)
              , INFO12: escape(this.editedItem.INFO12)
              , INFO13: escape(this.editedItem.INFO13)
              , INFO14: escape(this.editedItem.INFO14)
              , INFO15: escape(this.editedItem.INFO15)
              , INFO16: escape(this.editedItem.INFO16)
              , INFO17: escape(this.editedItem.INFO17)
              , INFO18: escape(this.editedItem.INFO18)
              , INFO19: escape(this.editedItem.INFO19)
              , INFO20: escape(this.editedItem.INFO20)
              , KEY1: escape(this.editedItem.KEY1)
              , KEY2: escape(this.editedItem.KEY2)
              , KEY3: escape(this.editedItem.KEY3)
              , KEY4: escape(this.editedItem.KEY4)
              , KEY5: escape(this.editedItem.KEY5)
              , KEY6: escape(this.editedItem.KEY6)
              , KEY7: escape(this.editedItem.KEY7)
              , KEY8: escape(this.editedItem.KEY8)
              , KEY9: escape(this.editedItem.KEY9)
              , KEY10: escape(this.editedItem.KEY10)
              , COMMENT: this.editedItem.COMMENT == null || this.editedItem.COMMENT == undefined ? "" : escape(this.editedItem.COMMENT)
              , COMMENT2: this.editedItem.COMMENT2 == null || this.editedItem.COMMENT2 == undefined ? "" : escape(this.editedItem.COMMENT2)
              , TEL: tel
              , EMAIL: this.editedItem.EMAIL == null || this.editedItem.EMAIL == undefined ? "" : escape(this.editedItem.EMAIL)
              , SEX: this.editedItem.SEX == null || this.editedItem.SEX == undefined ? 1 : this.editedItem.SEX
              , ISFOREIGNER: this.editedItem.ISFOREIGNER == null || this.editedItem.ISFOREIGNER == undefined ? 0 : this.editedItem.ISFOREIGNER
              , YEAR: this.editedItem.YEAR == null || this.editedItem.YEAR == undefined ? "1985" : this.editedItem.YEAR
              , NATION: this.editedItem.NATION == null || this.editedItem.NATION == undefined ? "KR" : this.editedItem.NATION
              , PRINT_NUMBER: this.editedItem.PRINT_NUMBER == null || this.editedItem.PRINT_NUMBER == undefined ? "0000" : this.editedItem.PRINT_NUMBER
              , REG_TYPE: this.editedItem.REG_TYPE
              , STATE: this.editedItem.STATE
              , REGSORT: this.editedItem.REGSORT
              , SORT: this.editedItem.SORT
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , OPTION_IDX: this.editedItem.OPTION_IDX
              , USER_IDX: this.editedItem.USER_IDX  == undefined ? null : this.editedItem.USER_IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });
      

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }
        

        this.close()
      },      

      //검색
      search_run(){

        if(this.checkdate){
          if(this.search_start_date.length < 4){
            this.$alert(this.$t('common_search_start_info1'));
            return;
          }
          if(this.search_end_date.length < 4){
            this.$alert(this.$t('common_search_end_info1'));
            return;
          }
          if(this.search_start_date > this.search_end_date){
            this.$alert(this.$t('common_search_date_error1'));
            return;
          }
        }


        this.loadpage(1);

      },
      
      //신규 추가
      newinsert(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)

        this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        this.dialog = true;
      },

      //결제내역 확인
      payment_item(item){

        this.$alert(item);

      },

      //아이템 수정
      edit_item(item){
        
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('eul_msg92'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('eul_msg93'));
          return;
        }

        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item);
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);

        //기존의 선택된 내용 초기화
        this.selectList.splice(0, this.selectList.length);
        this.selectList.push(this.editedItem);


        this.dialog = true;
      },

      //QR코드로 조회한 사람 보여주기
      edit_itemQR(item){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('eul_msg92'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('eul_msg93'));
          return;
        }
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = 1;
        this.editedItem = Object.assign({}, item);

        //기존의 선택된 내용 초기화
        this.selectList.splice(0, this.selectList.length);
        this.selectList.push(this.editedItem);

        this.dialog = true;
      },


      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/VisitorDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        this.sort_name = "IDX";
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          //헤더 처리
          this.headers.splice(0, this.headers.length);
          //기본정보 표시
          this.headers = [
            {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
            {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
            {text: '등록번호', value: 'IDX', width:100, sortable: false, align:'center' },
            {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
            {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
            {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
            {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
            {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
            {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
            {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
            {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },

            {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
            {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

            {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
            {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
            {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },
            
            {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
            {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
            
            {text: '만족도조사', value: 'ISINSPECT', width:120,sortable: false, align:'center' },
            {text: '마케팅동의', value: 'MKTAGREE', width:120,sortable: false, align:'center' },
            
            {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
            {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
          ];

        }
        this.loadpage(1);
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        this.sort_name = "IDX";
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          //infoItem 가져오기
          this.getInfoItemList();
          this.getEventOption();
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
          //헤더 처리
          this.headers.splice(0, this.headers.length);
          //기본정보 표시
          this.headers = [
            {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
            {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
            {text: '등록번호', value: 'IDX', width:100, sortable: false, align:'center' },
            {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
            {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
            {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
            {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
            {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
            {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
            {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
            {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },
            
            {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
            {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

            {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
            {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
            {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },
            
            {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
            {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
            
            {text: '만족도조사', value: 'ISINSPECT', width:120,sortable: false, align:'center' },
            {text: '마케팅동의', value: 'MKTAGREE', width:120,sortable: false, align:'center' },
            
            {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
            {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
          ];
        }
        this.loadpage(1);
      },

      priceToString(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },

      //행사별 행사옵션 가져오기
      getEventOption(){

        this.optionItem.splice(0, this.optionItem.length);                  //데이터 초기화
        this.search_optionItem.splice(0, this.search_optionItem.length);    //데이터 초기화
        this.SEARCH_OPTION = -1;
        
        if(this.SEARCH_COM_IDX == null){
            return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          return;
        }

        this.$http.post(this.$host+'/api/EventOptionList',{
              COMIDX: this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{

          if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              const list = result.data.resultData;
              this.search_optionItem.push({NAME:"전체", NAME_ENG:"All", IDX:-1});
              list.forEach(element => {
                if(element.STATE == 1){
                  this.optionItem.push(element);
                  this.search_optionItem.push(element);
                }
              });
          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });        

      },


      //행사별 기본접수양식 가져오기
      getInfoItemList(){
        
        this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
        
        if(this.SEARCH_COM_IDX == null){
            return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          return;
        }

        this.$http.post(this.$host+'/api/InputEventList',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , COM_IDX:   this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.useInfo = result.data.useData;

              const list = result.data.resultData;
              list.forEach(element => {
                  this.infoItem.push(element); 
              });


              //헤더 처리
              this.headers.splice(0, this.headers.length);
              if(this.SEARCH_COM_IDX != null && this.SEARCH_COM_IDX != undefined && this.SEARCH_EVENT_IDX != null && this.SEARCH_EVENT_IDX != undefined){
                //해당 행사 전용 정보 표시
                this.headers = [
                  {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
                  {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
                  {text: '등록번호', value: 'IDX', width:100, sortable: false, align:'center' },
                  {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
                  {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
                  {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
                  {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
                  {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
                  {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
                  {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
                  {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },
                  
                ];

                
                for(var i=1;i<this.infoItem.length;i++){
                  if(this.infoItem[i].SHOWTYPE == 1){
                    //사용일 경우
                    this.headers.push({text: this.infoItem[i].NAME, value: 'INFO'+(i+1), width:150, sortable: false, align:'center' });
                  }
                }

                
                this.headers.push({text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' });
                this.headers.push({text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' });

                this.headers.push({text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' });
                this.headers.push({text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' });
                this.headers.push({text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' });
                
                this.headers.push({text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' });
                this.headers.push({text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' });
                
                this.headers.push({text: '만족도조사', value: 'ISINSPECT', width:200,sortable: false, align:'center' });
                this.headers.push({text: '마케팅동의', value: 'MKTAGREE', width:200,sortable: false, align:'center' });
                
                this.headers.push({text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'});
                this.headers.push({text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'});
                
              }else{
                
                //기본정보 표시
                this.headers = [
                  {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
                  {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
                  {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
                  {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
                  {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
                  {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
                  {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
                  {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
                  {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
                  {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },

                  {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
                  {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

                  {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
                  {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
                  {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },
                  
                  {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
                  {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
                  
                  {text: '만족도조사', value: 'ISINSPECT', width:100,sortable: false, align:'center' },
                  {text: '마케팅동의', value: 'MKTAGREE', width:100,sortable: false, align:'center' },
                  
                  {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
                  {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
                ];

              }

              this.loading = false;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.sort_name = "IDX";
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          //헤더 처리
          this.headers.splice(0, this.headers.length);
          //기본정보 표시
          this.headers = [
            {text: '등록 No.', value: 'REGSORT', width:100, sortable: false, align:'center' },
            {text: '순서', value: 'SORT', width:100, sortable: false, align:'center' },
            {text: '등록 카테고리', value: 'OPTION_NAME', width:200,sortable: false, align:'center' },
            {text: '등록 타입', value: 'REGTYPE_NAME', width:80,sortable: false, align:'center' },
            {text: '상태', value: 'STATE_NAME', width:80,sortable: false, align:'center'},
            {text: '회원', value: 'USER_TYPENAME', width:80,sortable: false, align:'center'},
            {text: '구분', value: 'ISFOREIGNER', width:100,sortable: false, align:'center'},
            {text: '이름', value: 'INFO1', width:150, sortable: false, align:'center'},
            {text: '전화번호', value: 'TEL', width:150,sortable: false, align:'center' },
            {text: '이메일', value: 'EMAIL', width:150,sortable: false, align:'center' },

            {text: '등록일시', value: 'REG_DATE', width:200,sortable: false, align:'center' },
            {text: '결제일시', value: 'PAY_DATE', width:200,sortable: false, align:'center' },

            {text: '등록비', value: 'OPTION_COST', width:150,sortable: false, align:'right' },
            {text: '결제금액', value: 'COST', width:150,sortable: false, align:'right' },
            {text: '정산금액', value: 'CAL_COST', width:150,sortable: false, align:'right' },
            
            {text: '출력일시', value: 'PRINT_DATE', width:200,sortable: false, align:'center' },
            {text: '출력횟수', value: 'PRINTCNT', width:200,sortable: false, align:'center' },
            
            {text: '만족도조사', value: 'ISINSPECT', width:100,sortable: false, align:'center' },
            {text: '마케팅동의', value: 'MKTAGREE', width:100,sortable: false, align:'center' },
            
            {text: '결제내역', value: 'payment', width:100,sortable: false, align:'center'},
            {text: '수정/삭제', value: 'actions', width:100,sortable: false, align:'center'}
          ];

          this.search_run();
      },

      //국가선택 콜백
      nationcallback(var1){
        if(var1.NAMEKOR.length > 0){
          this.editedItem.NATION  = var1.NACODE;
          this.editedItem.NAMEKOR = var1.NAMEKOR;
        }
      },

      //국가선택 콜백
      nationcallbackExcel(var1){
        if(var1.NAMEKOR.length > 0){
          this.excelItem.NATION  = var1.NACODE;
          this.excelItem.NAMEKOR = var1.NAMEKOR;
        }
      },

      loadevent(eidx){

          this.$http.post(this.$host+'/api/EventDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.eventItem = list[0];
                this.dialog_event = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },

      loadoption(eidx, oidx){

          this.$http.post(this.$host+'/api/EventOptionDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , OPTION_IDX: oidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.odItem = list[0];
                this.dialog_option = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      loadvisitor(vidx, eidx){

          this.$http.post(this.$host+'/api/VisitorDetail',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , VISITOR_IDX: vidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.visitorItem = list[0];
                this.dialog_user = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      //출력 히스토리
      getprintlist(vidx, eidx){

          this.$http.post(this.$host+'/api/VPrintList',{
                search_type:''
              , search_keyword: ''
              , sort_type: ''
              , page: 1
              , pagerow: 9999
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX: eidx
              , VISITOR_IDX: vidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.printItem.splice(0, this.printItem.length);
                list.forEach(element => {
                    this.printItem.push(element); 
                });
                this.dialog_print = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      //결제내역 히스토리
      getpaymentlist(vidx, eidx){

          this.payment_visitor_idx = vidx;
          this.payment_event_idx = eidx;

          this.$http.post(this.$host+'/api/PaymentList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , EVENT_IDX:   eidx
              , VISITOR_IDX: vidx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.paymentItem.splice(0, this.paymentItem.length);
                list.forEach(element => {
                    this.paymentItem.push(element); 
                });
                this.dialog_payment = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },

      //환불규정
      getrefundlist(eidx, cidx){

          this.$http.post(this.$host+'/api/EventRefundList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: cidx
              , EVENT_IDX:   eidx
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                this.refundItem.splice(0, this.refundItem.length);
                list.forEach(element => {
                    this.refundItem.push(element); 
                });
                this.dialog_refund = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },


      //아임포트 환불
      cancel_payment(item){
        
        this.$confirm(this.$t('eul_msg94'))
        .then(() => {
                  
          this.$http.post(this.$host+'/api/cancelIamCode',{
                ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , EVENT_IDX: this.payment_event_idx
              , OPTION_IDX: item.OPTION_IDX
              , VISITOR_IDX: this.payment_visitor_idx
              , IAMCODE: item.IAMCODE
              , MIDCODE: item.MIDCODE
              , PAYMENTNAME: escape(item.PAYMENTNAME)
              , COST: item.COST
              , COST_TYPE: item.COST_TYPE
              , NAME: escape(item.NAME)
              , TEL: item.TEL
              , EMAIL: item.EMAIL
              , PG: item.PG
              , PAYMETHOD: item.PAYMETHOD
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.$alert(this.$t('eul_msg96'));
                this.dialog_payment = false;
                this.loadpage(1);

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('eul_msg97')+result.data.resultMsg);
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

        


        });

      },
      
      //아임포트 결제정보 
      getiamport(icode){

          this.$http.post(this.$host+'/api/getIamCode',{
              IAMCODE: icode
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                this.iamData = result.data.resultData
                this.dialog_iam = true;
                

            }else if(result.data.resultCode == 2){

              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
          });

      },      

      selectemailtemplate(item){
        //console.log("selectemailtemplate");
        //console.log(JSON.stringify(item));

        this.emailItem = item;

      },


      selectemail_com(item){
        if(item != null){
          this.SELECT_EMAIL_IDX  = item.EMAIL_IDX;
          this.SELECT_EMAIL_NAME = item.LAYOUT_NAME;
        }else{
          this.SELECT_EMAIL_IDX  = null;
          this.SELECT_EMAIL_NAME = null;
        }
      },

      //이미지 상세보기
      showImage(input_code){
        this.$viewerApi({
          images: [this.editedItem['INFO'+input_code]],
        })
      },

      clearFile(input_code){
        this.editedItem['INFO'+input_code] = null;
        this.$forceUpdate();
      },

      linkadd(input_code){
        this.LINKADDR = "";
        this.link_index = input_code;
        this.link_dialog = true;
      },

      fileSelect(item){
        const changefunction = this.changefile;
        var input = document.createElement("input");
        input.style = "display:none";
        input.name = "imageinputcamera";
        input.type = "file";
        input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

        let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
        if(indexcnt > -1){
          //아이폰, 아이패드, 맥
          //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
          document.body.appendChild(input);
          input.onchange = function (event) {
            //추가된 input 제거
            document.body.removeChild(input);
            changefunction(event.target.files[0], item);
          };
        }else{
          input.onchange = function (event) {
            changefunction(event.target.files[0], item);
          };
        }
        input.click();
      },


      fileSelect_all(item){
        const changefunction = this.changefile_all;
        var input = document.createElement("input");
        input.style = "display:none";
        input.name = "inputfile";
        input.type = "file";
        input.accept = "*"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

        let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
        if(indexcnt > -1){
          //아이폰, 아이패드, 맥
          //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
          document.body.appendChild(input);
          input.onchange = function (event) {
            //추가된 input 제거
            document.body.removeChild(input);
            changefunction(event.target.files[0], item);
          };
        }else{
          input.onchange = function (event) {
            changefunction(event.target.files[0], item);
          };
        }
        input.click();
      },      

      //링크 저장
      save_link(){
        const urlVal = /https?:\/\//;
        const checklink = cmvalidation.checkValReg(this.LINKADDR, urlVal, -1, 255, false);
        if(checklink == 1){
          this.$alert(this.$t('eul_msg98'));
          return false;
        }else if(checklink == 2){
          this.$alert(this.$t('eul_msg99'));
          return false;
        }else if(checklink == 4){
          this.$alert(this.$t('eul_msg100'));
          return false;
        }              
        this.editedItem['INFO'+this.link_index] = this.LINKADDR;
        this.link_dialog = false;
      },


      //이미지 선택시 크롭창 띄우기
      changefile(file, item){
        if(file.size/1024/1024 > 10){
          this.$alert(this.$t('eul_msg101'));
          return;
        }
        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          this.photo_index           = item.INPUT_CODE;
          this.option.autoCropWidth  = item.WIDTH;
          this.option.autoCropHeight = item.HEIGHT;
          this.option.fixedNumber    = [item.WIDTH, item.HEIGHT];
          this.crop_dialog = true;
          this.imgSrc = event.target.result;  //이게 blob데이터
        }
        reader.readAsDataURL(file);  //비동기로 파일을 읽어서
      },


      //이미지 크롭시
      cropimg(){
        //이미지 크롭 
        this.$refs.cropper_land.getCropBlob(blob=>{
          this.crop_dialog = false;
          this.uploadimage(blob);
        });
      },

      //일반 모든 파일
      async changefile_all(file, item){
        
        const fname = file.name;

        if(file.size/1024/1024 > 10){
          this.$alert(this.$t('eul_msg101'));
          return;
        }
        
        //s3에 파일 업로드 경로
        var albumPhotosKey = encodeURIComponent("visitor") + "/" + encodeURIComponent(this.editedItem.EVENT_IDX) + "/";

        //이미지 업로드
        var filename = this.editedItem.IDX+"_"+this.editedItem.INFO1+"_"+Date.now().toString()+"."+fname.split('.').pop();
        var photoKey = albumPhotosKey + filename;   
        const stored1 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: file,
                                                ACL: "public-read"
                                              }).promise();
        
        this.editedItem['INFO'+item.INPUT_CODE] = stored1.Location;

        console.log("stored1.Location : " + stored1.Location);

        this.$forceUpdate();

      },


      //url의 마지막 /이후의 값을 가져온다.
      async getLastPath(path_url){
        var array = path_url.split('/');
        return array[array.length-1];
      },

      async uploadimage(blob){

        //s3에 파일 업로드 경로
        var albumPhotosKey = encodeURIComponent("visitor") + "/" + encodeURIComponent(this.editedItem.EVENT_IDX) + "/";

        //이미지 업로드
        var filename = Date.now().toString()+".jpg";
        var photoKey = albumPhotosKey + filename;   
        const stored1 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: blob,
                                                ACL: "public-read"
                                              }).promise();
        
        this.editedItem['INFO'+this.photo_index] = stored1.Location;
        this.$forceUpdate();
        

      },


      //폰트로드 감지
      observeFontLoad(fontFace) {
        const observer = new FontFaceObserver(fontFace.family);
        return observer.load();
      },
      


    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

  /* 프린트시 사이즈 (필수) */
  @page {
    size: 102mm 245mm;  /*A4 Size*/
    margin: 0;
    padding: 0;
  }


.qr-scanner {
  position: relative;
  width: 200px; /* QR 코드의 크기에 맞게 조정 */
  height: 200px;
}
.scanner-line {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: red;
  animation: scan-animation 2s linear infinite;
}

@keyframes scan-animation {
  0% {
    top: 0;
  }
  50% {
    top: 100%;
  }
  100% {
    top: 0;
  }
}  

.resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  cursor: col-resize;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;  
}

.resize-handle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.print-type-select {
  width: 90px;
  height: 32px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 8px;
  background-color: white;
  vertical-align: middle;
  display: inline-block;
}

.print-type-select:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

</style>